// old code
// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import {
//   Box,
//   Button,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from '@mui/material';
// import * as XLSX from 'xlsx';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
// import FieldData from './FieldData';
// import SearchImg from '../../assets/search.svg';
// import { useMain } from '../hooks/useMain';
// import { IoStar } from "react-icons/io5";
// import { FaDownload, FaFilePdf, FaFileExcel } from "react-icons/fa";
// import { MdClear } from "react-icons/md";
// import { setBillingFilter, setBillingPage, setBillingLimit, resetBillingSearchAndFilters, toggleDuesFilter } from '../../redux/slices/AllBillingSlice';
// import FilterBillPage from "./FilterBillPage";
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import Book1Billing from '../../assets/excel/Book1Bill.xlsx';

// const filterGenderWise = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
// ];

// const filterRatings = [
//   { value: 4, label: <>4 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
//   { value: 3, label: <>3 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
// ];

// const filterPaymentMethods = [
//   { value: 'Cash', label: 'Cash' },
//   { value: 'Wallet', label: 'Wallet' },
//   { value: 'Credit/Debit Card', label: 'Credit/Debit Card' },
//   { value: 'Gpay', label: 'GPay' },
//   { value: 'Paytm', label: 'Paytm' },
//   { value: 'PhonePe', label: 'PhonePe' },
// ];


// const AllBillings = ({ billType }) => {
//   const dispatch = useDispatch();
//   const billingFilters = useSelector(state => state.allBilling);
//   const {
//     limit,
//     page,
//     search,
//     sortValue,
//     startDate,
//     endDate,
//     selectedSortBy,
//     selectedGenderBy,
//     selectedRatingBy,
//     selectedPaymentMethods,
//     selectedServices,
//     selectedServiceProviders,
//     selectedProducts,
//     dues
//   } = billingFilters;

//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [showLoader, setShowLoader] = useState(true);
//   const [clear, setClear] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [services, setServices] = useState([]);
//   const [serviceProviders, setServiceProviders] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loadingServices, setLoadingServices] = useState(false);
//   const [loadingProviders, setLoadingProviders] = useState(false);
//   const [pageTotals, setPageTotals] = useState({ totalAmount: 0, amountPaid: 0, paidDues: 0 });
//   const [fullFilteredData, setFullFilteredData] = useState([]);
//   const [totalFilteredCount, setTotalFilteredCount] = useState(0);
//   const [ownerId, setOwnerId] = useState("")
//   const [debouncedSearch, setDebouncedSearch] = useState(search); //debounce state
//   const [allClient,setAllClient] = useState([])
//   const { fetchAllBillings, activeBranchId, getBranch, createManyBills, setShowMessage} = useMain();


//     useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedSearch(search);
//     }, 500); // 1000ms delay

//     return () => {
//       clearTimeout(handler); // agar user typing continue kare to purana timer clear hoga
//     };
//   }, [search]);

//   const fetchServicesAndStaff = async (activeBranchId) => {
//     try {
//       const res = await getBranch(activeBranchId);
//       const data = res?.data;
//       return {
//         services: data?.services || [],
//         staff: data?.staffs || [],
//         products: data?.products || [],
//         ownerId: data?.ownerId[0]?._id || "",
//         allClient:data?.client || []
//       };
//     } catch (error) {
//       console.error("Error fetching services and staff:", error);
//       return { services: [], staff: [], products: [] };
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoadingServices(true);
//       setLoadingProviders(true);
//       try {
//         const { services, staff, products, ownerId,allClient } = await fetchServicesAndStaff(activeBranchId);
//         setServices(services);
//         setServiceProviders(staff);
//         setProducts(products);
//         setOwnerId(ownerId);
//         setAllClient(allClient)
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoadingServices(false);
//         setLoadingProviders(false);
//       }
//     };
//     fetchData();
//   }, [activeBranchId]);

//   useEffect(() => {
//     dispatch(resetBillingSearchAndFilters());
//   }, [dispatch]);

//   // Bulk upload functions
//   // const handleFileChange = (e) => {
//   //   const selectedFile = e.target.files[0];
//   //   if (selectedFile) {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       const data = new Uint8Array(e.target.result);
//   //       const workbook = XLSX.read(data, { type: 'array' });
//   //       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//   //       const jsonData = XLSX.utils.sheet_to_json(firstSheet);
//   //       console.log(jsonData,'jsonDataaaa')
//   //       setUploadedData(jsonData);
//   //     };
//   //     reader.readAsArrayBuffer(selectedFile);
//   //   }
//   // };


//   //new code arpit
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonData = XLSX.utils.sheet_to_json(firstSheet);

//         // Transform the data to match your billing format
//         const formattedData = jsonData.map((item, index) => {
//           // Convert Excel date (numeric) to JavaScript Date object
//           const excelDate = item.dateOfBilling;
//           const jsDate = new Date((excelDate - 25569) * 86400 * 1000);

//           // Format date as YYYY-MM-DD
//           const formattedDate = jsDate.toISOString().split('T')[0];

//           // Convert Excel time (fraction of day) to HH:MM:SS
//           const excelTime = item.timeOfBilling;
//           const hours = Math.floor(excelTime * 24);
//           const minutes = Math.floor((excelTime * 24 - hours) * 60);
//           const seconds = Math.floor(((excelTime * 24 - hours) * 60 - minutes) * 60);
//           const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

//           // Initialize membership and package arrays
//           const membershipUniqueIds = [];
//           const packageUniqueIds = [];
//           let useMembership = false;
//           let usePackage = false;

//           // Transform services data into proper array format
//           const services = [];
//           let serviceIndex = 0;
//           while (item[`services[${serviceIndex}].serviceName`]) {
//             // Handle service providers - convert to array if needed
//             let serviceProviders = [];
//             if (item[`services[${serviceIndex}].serviceProvider`]) {
//               // If it's already an array, use it directly
//               if (Array.isArray(item[`services[${serviceIndex}].serviceProvider`])) {
//                 serviceProviders = item[`services[${serviceIndex}].serviceProvider`];
//               }
//               // If it's a string (single provider), convert to array
//               else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'string') {
//                 serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
//               }
//               // If it's an object, convert to array of objects
//               else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'object') {
//                 serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
//               }
//             }

//             // Handle membership for this service
//             const serviceMembershipUniqueId = item[`services[${serviceIndex}].membershipUniqueId`] || "";
//             const membershipApplied = !!serviceMembershipUniqueId;

//             // Handle package for this service
//             const servicePackageUniqueId = item[`services[${serviceIndex}].packageUniqueId`] || "";
//             const packageApplied = !!servicePackageUniqueId;

//             // Add to global membership/package tracking if exists
//             if (serviceMembershipUniqueId) {
//               membershipUniqueIds.push(serviceMembershipUniqueId);
//               useMembership = true;
//             }
//             if (servicePackageUniqueId) {
//               packageUniqueIds.push(servicePackageUniqueId);
//               usePackage = true;
//             }

//             services.push({
//               // _id: item[`services[${serviceIndex}]._id`] || `temp-${index}-${serviceIndex}`,
//               service: item[`services[${serviceIndex}].service`],
//               serviceName: item[`services[${serviceIndex}].serviceName`],
//               serviceProvider: serviceProviders,
//               category: item[`services[${serviceIndex}].category`] || "",
//               price: item[`services[${serviceIndex}].price`] || 0,
//               discount: item[`services[${serviceIndex}].discount`] || 0,
//               discountType: item[`services[${serviceIndex}].discountType`] || "%",
//               amount: item[`services[${serviceIndex}].amount`] || 0,
//               quantity: item[`services[${serviceIndex}].quantity`] || 1,
//               ...(serviceMembershipUniqueId && { membershipUniqueId: serviceMembershipUniqueId }),
//               // ...(membershipApplied && { membershipApplied: membershipApplied }) ,
//               ...(servicePackageUniqueId && { packageUniqueId: servicePackageUniqueId }),
//               // packageApplied: packageApplied || false
//             });
//             serviceIndex++;
//           }

//           // Transform amountPaid data
//           const amountPaid = [];
//           let paymentIndex = 0;
//           while (item[`amountPaid[${paymentIndex}].amount`]) {
//             amountPaid.push({
//               // _id: item[`amountPaid[${paymentIndex}]._id`] || `temp-pay-${index}-${paymentIndex}`,
//               amount: item[`amountPaid[${paymentIndex}].amount`],
//               paymentType: item[`amountPaid[${paymentIndex}].paymentType`]
//             });
//             paymentIndex++;
//           }

//           // Create the formatted bill object
//           return {
//             // _id: item._id || `temp-${index}`,
//             // invoice: item.invoice,
//             billType: item.billType || 'Bill',
//             clientName: item.clientName,
//             clientNumber: item.clientNumber.toString(), // Ensure it's a string
//             gender: item.gender,
//             dateOfBilling: formattedDate,
//             timeOfBilling: formattedTime,
//             services: services,
//             products: [], // Add product transformation if needed
//             amountPaid: amountPaid,
//             amountPayable: item.amountPayable,
//             subTotal: item.subTotal,
//             totalAmount: item.totalAmount || item.amountPayable || 0,
//             paidDues: item.paidDues || 0,
//             advancedGiven: item.advancedGiven || 0,
//             preAdvanceUsed: item.preAdvanceUsed || 0,
//             useMembership: useMembership || false,
//             usePackage: usePackage || false,
//             membershipUniqueIds: [...new Set(membershipUniqueIds)], // Remove duplicates
//             packageUniqueIds: [...new Set(packageUniqueIds)], // Remove duplicates
//             giveRewardPoints: item.giveRewardPoints || false,
//             taxes: item.taxes || {
//               PGST: 0,
//               SGST: 0,
//               taxType: "Inclusive"
//             },
//             coupon: item.coupon || {
//               couponCode: "",
//               couponId: null,
//               discountAmount: 0
//             },
//             discount: {
//               discountType: item.discount?.discountType || "%",
//               discount: item.discount?.discount || ""
//             },
//             branchDetails: activeBranchId,
//             availability: true,
//             // createdAt: new Date().toISOString(),
//             // updatedAt: new Date().toISOString()
//           };
//         });

//         setUploadedData(formattedData);
//       };
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };


//   const handleBulkUploadSubmit = async (e) => {
//     e.preventDefault();
//     if (!uploadedData) {
//       setShowMessage({ message: 'Please select a valid file', messageType: 'error' });
//       return;
//     }
//     try {
//       setShowLoader(true);
//       const res = await createManyBills(
//         activeBranchId,
//         JSON.stringify({ bulkData: uploadedData }),
//       );
//       if (res?.statusCode === 200) {
//         getData();
//         setShowMessage({
//           message: res.message || 'Bulk bill upload successful',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({
//           message: res.message || 'Bulk bill upload failed',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Bulk bill upload failed',
//         messageType: 'error',
//       });
//     } finally {
//       setShowLoader(false);
//       setIsBulkUploadModalOpen(false);
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const templateFileName = Book1Billing;
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = templateFileName;
//     a.download = 'billing_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };

//   const openBulkUploadModal = () => {
//     setIsBulkUploadModalOpen(true);
//   };

//   const closeBulkUploadModal = () => {
//     setIsBulkUploadModalOpen(false);
//   };

//   // Rest of your existing functions...
//   const getPaymentMethods = () => {
//     if (billType === 'Wallet') {
//       return filterPaymentMethods.filter(method => method.value !== 'Wallet');
//     }
//     return filterPaymentMethods;
//   };

//   const filterOptions = [
//     {
//       title: 'Gender',
//       items: filterGenderWise,
//     },
//     {
//       title: 'Ratings',
//       items: filterRatings,
//     },
//     {
//       title: 'Payment Method',
//       items: getPaymentMethods(),
//     },
//     {
//       title: 'Services',
//       items: services.map((service) => ({
//         value: service._id,
//         label: service.serviceName,
//         gender: service.gender,
//       })),
//     },
//     {
//       title: 'Products',
//       items: products.map((product) => ({
//         value: product._id,
//         label: product.productName,
//         gender: product.gender,
//       })),
//     },
//     {
//       title: 'Service Providers',
//       items: serviceProviders.map((provider) => ({
//         value: provider._id,
//         label: provider.name,
//         gender: provider.gender,
//       })),
//     },
//     // {
//     //   title: 'Dues',
//     //   items: [
//     //     { value: 'hasDues', label: 'Show only bills with dues' }
//     //   ]
//     // }
//   ];

//   const handleFilterChange = (selectedValues) => {
//     const serviceIds = selectedValues.filter(val =>
//       services.some(service => service._id === val)
//     );
//     const productIds = selectedValues.filter(val =>
//       products.some(product => product._id === val)
//     );
//     const providerIds = selectedValues.filter(val =>
//       serviceProviders.some(provider => provider._id === val)
//     );
//     const genderFilters = selectedValues.filter(val =>
//       filterGenderWise.some(opt => opt.value === val)
//     );
//     const ratingFilters = selectedValues.filter(val =>
//       filterRatings.some(opt => opt.value === val)
//     );
//     const paymentFilters = selectedValues.filter(val =>
//       getPaymentMethods().some(opt => opt.value === val)
//     );

//     const dues = selectedValues.includes('hasDues');

//     dispatch(setBillingFilter({
//       selectedGenderBy: genderFilters,
//       selectedRatingBy: ratingFilters,
//       selectedPaymentMethods: paymentFilters,
//       selectedServices: serviceIds,
//       selectedServiceProviders: providerIds,
//       selectedProducts: productIds,
//       page: 1
//     }));
//   };

// const hasActiveFilters = () => {
//   return (
//     search ||
//     startDate ||
//     endDate ||
//     selectedSortBy.length > 0 ||
//     selectedGenderBy.length > 0 ||
//     selectedRatingBy.length > 0 ||
//     selectedPaymentMethods.length > 0 ||
//     selectedServices.length > 0 ||
//     selectedServiceProviders.length > 0 ||
//     selectedProducts.length > 0 ||
//     dues
//   );
// };

// const getData = async (isFiltered = false) => {

//   // Always use the current page value from Redux state, not a hardcoded value
//   const queryParams = {
//     limit: isFiltered ? 10000 : limit,
//     page: isFiltered ? 1 : page, // Use current page from state
//     billType,
//     sortValue,
//     ...(search && { searchValue: search.trim() }),
//     ...(startDate && { startDate: startDate.trim() }),
//     ...(endDate && { endDate: endDate.trim() }),
//     ...(selectedSortBy.length > 0 && { sortBy: selectedSortBy.join(',') }),
//     ...(selectedGenderBy.length > 0 && { gender: selectedGenderBy.join(',') }),
//     ...(selectedRatingBy.length > 0 && { ratings: selectedRatingBy.join(',') }),
//     ...(selectedPaymentMethods.length > 0 && { paymentMethod: selectedPaymentMethods.join(',') }),
//     ...(selectedServices.length > 0 && { services: selectedServices.join(',') }),
//     ...(selectedServiceProviders.length > 0 && { staff: selectedServiceProviders.join(',') }),
//     ...(selectedProducts.length > 0 && { products: selectedProducts.join(',') }),
//     ...(dues && { dues: true }),
//   };

//   const queryString = Object.entries(queryParams)
//     .filter(([_, value]) => value !== undefined && value !== '')
//     .map(([key, value]) => `${key}=${value}`)
//     .join('&');

//   try {
//     setShowLoader(true);
//     const res = await fetchAllBillings(activeBranchId, `?${queryString}`);

//     if (res.statusCode === 200) {
//       if (isFiltered) {
//         setFullFilteredData(res.data || []);
//         setTotalFilteredCount(res.data?.length || 0);
//         const startIndex = (page - 1) * limit;
//         const endIndex = startIndex + limit;
//         setFilteredData(res.data.slice(startIndex, endIndex) || []);
//       } else {
//         setData(res.data || []);
//         setFilteredData(res.data || []);
//         setTotalFilteredCount(res.totalCount || 0);
//       }
//     }
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   } finally {
//     setShowLoader(false);
//   }
// };
// useEffect(() => {
//   const filtersActive = hasActiveFilters();
//   getData(filtersActive);

//   if (!filtersActive) {
//     setIsModalOpen(false);
//   }
// }, [
//   activeBranchId,
//   billType,
//   limit,
//   page, // This dependency will trigger getData when page changes
//   debouncedSearch,
//   startDate,
//   endDate,
//   selectedSortBy,
//   sortValue,
//   selectedGenderBy,
//   selectedRatingBy,
//   selectedPaymentMethods,
//   selectedServices,
//   selectedServiceProviders,
//   selectedProducts,
//   dues,
//   clear
// ]);

//   // useEffect(() => {
//   //   if (startDate && endDate && fullFilteredData.length > 0) {
//   //     const startIndex = (page - 1) * limit;
//   //     const endIndex = startIndex + limit;
//   //     setFilteredData(fullFilteredData.slice(startIndex, endIndex));
//   //     setTotalFilteredCount(fullFilteredData.length);
//   //   }
//   // }, [page, limit, startDate, endDate, fullFilteredData]);

//   useEffect(() => {
//     const totals = calculatePageTotals(filteredData);
//     setPageTotals(totals);
//   }, [filteredData]);

//   const calculatePageTotals = (currentPageData) => {
//     const totalAmount = currentPageData.reduce((acc, item) => acc + (item.amountPayable || 0), 0);
//     const amountPaid = currentPageData.reduce((acc, item) => {
//       if (Array.isArray(item.amountPaid)) {
//         const totalPaid = item.amountPaid.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
//         return acc + totalPaid;
//       }
//       return acc;
//     }, 0);
//     const paidDues = currentPageData.reduce((acc, item) => acc + (item.paidDues || 0), 0);

//     return { totalAmount, amountPaid, paidDues: isNaN(paidDues) ? 0 : paidDues };
//   };

//   const handleLimitChange = (e) => {
//     console.log(e.target.value,'pagevalue')
//     dispatch(setBillingLimit(e.target.value));
//   };

//   const handleOnExport = () => {
//     const exportData = startDate && endDate ? fullFilteredData : data;
//     if (!Array.isArray(exportData)) {
//       console.error('Data is not an array or is undefined');
//       return;
//     }

//     const selectedFields = [
//       'clientName', 'clientNumber', 'gender', 'useMembership', 'dateOfBilling', 'timeOfBilling',
//       'subTotal', 'totalAmount', 'amountPayable', 'paidDues', 'advancedGiven', 'preAdvanceUsed',
//       'ratings',
//     ];

//     const flattenedData = exportData.map((item) => {
//       const flattenedItem = {};
//       selectedFields.forEach((field) => {
//         if (item.hasOwnProperty(field)) {
//           flattenedItem[field] = item[field];
//         }
//       });
//       if (Array.isArray(item.amountPaid)) {
//         flattenedItem.amountPaid = item.amountPaid.reduce((total, item) => total + parseFloat(item.amount), 0);
//       }
//       if (Array.isArray(item.services)) {
//         flattenedItem.serviceName = item.services.map(serviceItem => serviceItem.serviceName).join(', ');
//         flattenedItem.serviceProviders = item.services.map(serviceItem => serviceItem.serviceProvider?.name || '').join(', ');
//       }
//       if (Array.isArray(item.products)) {
//         flattenedItem.productName = item.products.map(productItem => productItem.productName).join(', ');
//         flattenedItem.productProvider = item.products.map(productItem => productItem.providerStaff?.name || '').join(', ');
//       }
//       return flattenedItem;
//     });

//     let wb = XLSX.utils.book_new();
//     let ws = XLSX.utils.json_to_sheet(flattenedData);
//     XLSX.utils.book_append_sheet(wb, ws, 'Bills');
//     XLSX.writeFile(wb, 'Bills.xlsx');
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const handleDateRangeSelected = (startDate, endDate) => {
//     dispatch(setBillingFilter({ startDate, endDate, page: 1 }));
//     setClear(true);
//     setIsModalOpen(false);
//   };

//   return (
//     <>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0px 1.5rem 30px' }}>
//         {/* Show per page - Left side */}
//         <div style={{ width: '100px', marginBottom: '20px' }}>
//           <InputLabel>Show per page</InputLabel>
//           <Select
//             style={{
//               borderRadius: '7px',
//               border: '0.5px solid #6174DD',
//               padding: '4px 12px',
//               background: '#FFF',
//               height: '40px',
//               width: '100%',
//             }}
//             value={limit}
//             onChange={handleLimitChange}
//           >
//             {[10,50,100,200].map((value) => (
//               <MenuItem key={value} value={value}>
//                 {value}
//               </MenuItem>
//             ))}
//           </Select>
//         </div>

//         {/* Right side buttons: Search, Filter, Download */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
//           {/* Search */}
//           <div style={{ width: '130px', marginBottom: '25px' }} onClick={() => document.getElementById('search-input').focus()}>
//             <InputLabel>Search</InputLabel>
//             <div className="search-input" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
//               <img src={SearchImg} alt="" style={{ verticalAlign: 'middle' }} />
//               <input
//                 id="search-input"
//                 style={{ flex: 1, padding: '4px 2px', borderRadius: '7px', width: '100%' }}
//                 type="text"
//                 placeholder=""
//                 value={search}
//                 onChange={(e) => dispatch(setBillingFilter({ search: e.target.value }))}
//               />
//               {search && (
//                 <IconButton
//                   onClick={() => {
//                     dispatch(setBillingFilter({ search: '' }));
//                     setClear(false);
//                   }}
//                   style={{ padding: 1 }}
//                 >
//                   <MdClear style={{ color: '#000', marginRight: '-0.1rem', marginTop: '0.1rem', fontSize: '1.1rem' }} />
//                 </IconButton>
//               )}
//             </div>
//           </div>

//           {/* Filter */}
//           <div style={{ width: '150px' }}>
//             <FilterBillPage
//               options={filterOptions}
//               value={[
//                 ...selectedGenderBy,
//                 ...selectedRatingBy,
//                 ...selectedPaymentMethods,
//                 ...selectedServices,
//                 ...selectedServiceProviders,
//                 ...selectedProducts,
//               ]}
//               onChange={handleFilterChange}
//               placeholder="Filters"
//               selectedStartDate={startDate}
//               selectedEndDate={endDate}
//               onDateRangeSelected={(start, end) => {
//                 dispatch(setBillingFilter({ startDate: start, endDate: end }));
//               }}
//               onClearDate={() => {
//                 dispatch(setBillingFilter({ startDate: '', endDate: '' }));
//               }}
//               loadingServices={loadingServices}
//               loadingProviders={loadingProviders}
//               hasDues={dues}
//               onToggleDues={(newDuesValue) => {
//                 dispatch(setBillingFilter({ dues: newDuesValue, page: 1 }));
//               }}
//                 products={products} // Add this line to pass products
//               onProductSelectionChange={(selectedProductIds) => {
//                 dispatch(setBillingFilter({ selectedProducts: selectedProductIds, page: 1 }));
//               }}
//             />
//           </div>

//           {/* Bulk Upload Button */}
//           {/* <div style={{ width: '150px' }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={openBulkUploadModal}
//               sx={{
//                 height: '40px',
//                 width: '100%',
//                 padding: '0.3rem',
//                 '&:hover': { background: '#6174DD' },
//               }}
//             >
//               Bulk Upload
//             </Button>
//           </div> */}

//           {/* Download Button */}
//            <div style={{ width: '70px' }}>
//             <Button
//               variant="contained"
//               color="primary"
//               title="Download Bills"
//               sx={{
//                 height: '40px',
//                 width: '100%',
//                 padding: '0.3rem',
//                 '&:hover': { background: '#6174DD' },
//               }}
//               onClick={handleOnExport}
//             >
//               <FaDownload style={{ height: '1.6rem', fontSize: '1.2rem' }} />
//             </Button>
//           </div> 
//         </div>
//       </div>

//       {showLoader ? (
//         <ShowLoader />
//       ) : (
//         <Box>
//           {filteredData && filteredData.length > 0 ? (
//             <Grid container spacing={3}>
//               <Grid item xs={12} lg={12}>
//                 <FieldData
//                   data={filteredData}
//                   setData={setData}
//                   getData={getData}
//                   billType={billType}
//                   ownerId={ownerId}
//                   allClient={allClient}
//                 />
//               </Grid>
//             </Grid>
//           ) : (
//             <div style={{ marginTop: '2rem' }} variant="h6" align="center">
//               No data found
//             </div>
//           )}
//         </Box>
//       )}

//       <Box display={'flex'} justifyContent={'flex-end'}>
//         <Pagination
//           count={hasActiveFilters() ? Math.ceil(totalFilteredCount / limit) : page + 1}
//           page={page}
//           color="primary"
//           onChange={(e, newPage) => {
//             dispatch(setBillingPage(newPage));
//             // getData(hasActiveFilters());
//           }}
//         />
//       </Box>

//       <Box
//         display="flex"
//         flexDirection="column"
//         style={{
//           width: '100%',
//           marginLeft: '0.5rem',
//           marginTop: '1rem',
//           padding: '1rem',
//           boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//           borderRadius: '8px',
//         }}
//       >
//         <Typography variant="h6" fontWeight="600" gutterBottom>
//           Amount as per Page
//         </Typography>

//         <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Amount:</strong> ₹ {pageTotals.totalAmount}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Paid:</strong> ₹ {pageTotals.amountPaid}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Pending:</strong> ₹ {pageTotals.paidDues}
//           </Typography>
//         </Box>
//       </Box>

//       {/* Bulk Upload Modal */}
//       <Dialog open={isBulkUploadModalOpen} onClose={closeBulkUploadModal}>
//         <DialogTitle>Bulk Upload Bills</DialogTitle>
//         <form onSubmit={handleBulkUploadSubmit}>
//           <DialogContent>
//             <input
//               type="file"
//               accept=".xlsx, .xls"
//               onChange={handleFileChange}
//             />
//             {showLoader && <ShowLoader />}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={closeBulkUploadModal}>Cancel</Button>
//             {/* <Button 
//               variant="outlined"
//               color="primary"
//               onClick={downloadExcelTemplate}
//               startIcon={<ArrowCircleDownIcon />}
//             >
//               Sample Download
//             </Button> */}
//             <Button type="submit" variant="contained" color="primary">
//               Submit
//             </Button>
//           </DialogActions>
//         </form>
//       </Dialog>

//       <DateRangeInputs
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         onDateRangeSelected={handleDateRangeSelected}
//         selectedEndDate={endDate}
//         selectedStartDate={startDate}
//       />
//     </>
//   );
// };

// export default AllBillings;

// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import {
//   Box,
//   Button,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Chip,
//   CardContent,
//   Alert,
//   LinearProgress,
//   Snackbar,
// } from '@mui/material';
// import * as XLSX from 'xlsx';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
// import FieldData from './FieldData';
// import SearchImg from '../../assets/search.svg';
// import { useMain } from '../hooks/useMain';
// import { IoStar } from "react-icons/io5";
// import { FaDownload, FaFilePdf, FaFileExcel } from "react-icons/fa";
// import { MdClear } from "react-icons/md";
// import { setBillingFilter, setBillingPage, setBillingLimit, resetBillingSearchAndFilters, toggleDuesFilter } from '../../redux/slices/AllBillingSlice';
// import FilterBillPage from "./FilterBillPage";
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import Book1Billing from '../../assets/excel/Book1Bill.xlsx';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import TemplateSelectionDialog from './Templates/TemplateSelectionDialog';
// import { Card } from 'reactstrap';
// import { padding } from '@mui/system';

// const filterGenderWise = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
// ];

// const filterRatings = [
//   { value: 4, label: <>4 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
//   { value: 3, label: <>3 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
// ];

// const filterPaymentMethods = [
//   { value: 'Cash', label: 'Cash' },
//   { value: 'Wallet', label: 'Wallet' },
//   { value: 'Credit/Debit Card', label: 'Credit/Debit Card' },
//   { value: 'Gpay', label: 'GPay' },
//   { value: 'Paytm', label: 'Paytm' },
//   { value: 'PhonePe', label: 'PhonePe' },
// ];


// const AllBillings = ({ billType }) => {
//   const dispatch = useDispatch();
//   const billingFilters = useSelector(state => state.allBilling);
//   const {
//     limit,
//     page,
//     search,
//     sortValue,
//     startDate,
//     endDate,
//     selectedSortBy,
//     selectedGenderBy,
//     selectedRatingBy,
//     selectedPaymentMethods,
//     selectedServices,
//     selectedServiceProviders,
//     selectedProducts,
//     dues,
//   } = billingFilters;

//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [showLoader, setShowLoader] = useState(true);
//   const [clear, setClear] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [services, setServices] = useState([]);
//   const [serviceProviders, setServiceProviders] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loadingServices, setLoadingServices] = useState(false);
//   const [loadingProviders, setLoadingProviders] = useState(false);
//   const [pageTotals, setPageTotals] = useState({ totalAmount: 0, amountPaid: 0, paidDues: 0 });
//   const [fullFilteredData, setFullFilteredData] = useState([]);
//   const [totalFilteredCount, setTotalFilteredCount] = useState(0);
//   const [ownerId, setOwnerId] = useState("")
//   const [debouncedSearch, setDebouncedSearch] = useState(search); //debounce state
//   const [allClient, setAllClient] = useState([])

//   const [allFilteredDataForSelection, setAllFilteredDataForSelection] = useState([]);
//   const [checkedClients, setCheckedClients] = useState([]);
//   // Add isAllChecked state in AllBilling component
//   const [isAllChecked, setIsAllChecked] = useState(false);
//   const [openWhatsAppDialog, setOpenWhatsAppDialog] = useState(false);
//   const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
//   const [templates, setTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [templateVariables, setTemplateVariables] = useState({});
//   const [isSending, setIsSending] = useState(false);
//   const [sendProgress, setSendProgress] = useState(0);
//   const [sendError, setSendError] = useState(null);
//   const [validationError, setValidationError] = useState('');
//   const [hideDownloadButton, setHideDownloadButton] = useState(true)
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   const { fetchAllBillings, activeBranchId, getBranch, createManyBills, sendBulkWhatsApp, getWhatsAppTemplates, setShowMessage } = useMain();


//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedSearch(search);
//     }, 500); // 1000ms delay

//     return () => {
//       clearTimeout(handler); // agar user typing continue kare to purana timer clear hoga
//     };
//   }, [search]);

//   const fetchServicesAndStaff = async (activeBranchId) => {
//     try {
//       const res = await getBranch(activeBranchId);
//       const data = res?.data;
//       return {
//         services: data?.services || [],
//         staff: data?.staffs || [],
//         products: data?.products || [],
//         ownerId: data?.ownerId[0]?._id || "",
//         allClient: data?.client || [],
//         hideDownloadButton: data?.hideDownloadButton || false
//       };
//     } catch (error) {
//       console.error("Error fetching services and staff:", error);
//       return { services: [], staff: [], products: [] };
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoadingServices(true);
//       setLoadingProviders(true);
//       try {
//         const { services, staff, products, ownerId, allClient, hideDownloadButton } = await fetchServicesAndStaff(activeBranchId);

//         setServices(services);
//         setServiceProviders(staff);
//         setProducts(products);
//         setOwnerId(ownerId);
//         setAllClient(allClient)
//         setHideDownloadButton(hideDownloadButton)
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoadingServices(false);
//         setLoadingProviders(false);
//       }
//     };
//     fetchData();
//   }, [activeBranchId]);

//   useEffect(() => {
//     dispatch(resetBillingSearchAndFilters());

//     return () => dispatch(resetBillingSearchAndFilters());
//   }, [dispatch]);

//   // Bulk upload functions
//   // const handleFileChange = (e) => {
//   //   const selectedFile = e.target.files[0];
//   //   if (selectedFile) {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       const data = new Uint8Array(e.target.result);
//   //       const workbook = XLSX.read(data, { type: 'array' });
//   //       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//   //       const jsonData = XLSX.utils.sheet_to_json(firstSheet);
//   //       console.log(jsonData,'jsonDataaaa')
//   //       setUploadedData(jsonData);
//   //     };
//   //     reader.readAsArrayBuffer(selectedFile);
//   //   }
//   // };


//   //new code arpit
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonData = XLSX.utils.sheet_to_json(firstSheet);

//         // Transform the data to match your billing format
//         const formattedData = jsonData.map((item, index) => {
//           // Convert Excel date (numeric) to JavaScript Date object
//           const excelDate = item.dateOfBilling;
//           const jsDate = new Date((excelDate - 25569) * 86400 * 1000);

//           // Format date as YYYY-MM-DD
//           const formattedDate = jsDate.toISOString().split('T')[0];

//           // Convert Excel time (fraction of day) to HH:MM:SS
//           const excelTime = item.timeOfBilling;
//           const hours = Math.floor(excelTime * 24);
//           const minutes = Math.floor((excelTime * 24 - hours) * 60);
//           const seconds = Math.floor(((excelTime * 24 - hours) * 60 - minutes) * 60);
//           const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

//           // Initialize membership and package arrays
//           const membershipUniqueIds = [];
//           const packageUniqueIds = [];
//           let useMembership = false;
//           let usePackage = false;

//           // Transform services data into proper array format
//           const services = [];
//           let serviceIndex = 0;
//           while (item[`services[${serviceIndex}].serviceName`]) {
//             // Handle service providers - convert to array if needed
//             let serviceProviders = [];
//             if (item[`services[${serviceIndex}].serviceProvider`]) {
//               // If it's already an array, use it directly
//               if (Array.isArray(item[`services[${serviceIndex}].serviceProvider`])) {
//                 serviceProviders = item[`services[${serviceIndex}].serviceProvider`];
//               }
//               // If it's a string (single provider), convert to array
//               else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'string') {
//                 serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
//               }
//               // If it's an object, convert to array of objects
//               else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'object') {
//                 serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
//               }
//             }

//             // Handle membership for this service
//             const serviceMembershipUniqueId = item[`services[${serviceIndex}].membershipUniqueId`] || "";
//             const membershipApplied = !!serviceMembershipUniqueId;

//             // Handle package for this service
//             const servicePackageUniqueId = item[`services[${serviceIndex}].packageUniqueId`] || "";
//             const packageApplied = !!servicePackageUniqueId;

//             // Add to global membership/package tracking if exists
//             if (serviceMembershipUniqueId) {
//               membershipUniqueIds.push(serviceMembershipUniqueId);
//               useMembership = true;
//             }
//             if (servicePackageUniqueId) {
//               packageUniqueIds.push(servicePackageUniqueId);
//               usePackage = true;
//             }

//             services.push({
//               // _id: item[`services[${serviceIndex}]._id`] || `temp-${index}-${serviceIndex}`,
//               service: item[`services[${serviceIndex}].service`],
//               serviceName: item[`services[${serviceIndex}].serviceName`],
//               serviceProvider: serviceProviders,
//               category: item[`services[${serviceIndex}].category`] || "",
//               price: item[`services[${serviceIndex}].price`] || 0,
//               discount: item[`services[${serviceIndex}].discount`] || 0,
//               discountType: item[`services[${serviceIndex}].discountType`] || "%",
//               amount: item[`services[${serviceIndex}].amount`] || 0,
//               quantity: item[`services[${serviceIndex}].quantity`] || 1,
//               ...(serviceMembershipUniqueId && { membershipUniqueId: serviceMembershipUniqueId }),
//               // ...(membershipApplied && { membershipApplied: membershipApplied }) ,
//               ...(servicePackageUniqueId && { packageUniqueId: servicePackageUniqueId }),
//               // packageApplied: packageApplied || false
//             });
//             serviceIndex++;
//           }

//           // Transform amountPaid data
//           const amountPaid = [];
//           let paymentIndex = 0;
//           while (item[`amountPaid[${paymentIndex}].amount`]) {
//             amountPaid.push({
//               // _id: item[`amountPaid[${paymentIndex}]._id`] || `temp-pay-${index}-${paymentIndex}`,
//               amount: item[`amountPaid[${paymentIndex}].amount`],
//               paymentType: item[`amountPaid[${paymentIndex}].paymentType`]
//             });
//             paymentIndex++;
//           }

//           // Create the formatted bill object
//           return {
//             // _id: item._id || `temp-${index}`,
//             // invoice: item.invoice,
//             billType: item.billType || 'Bill',
//             clientName: item.clientName,
//             clientNumber: item.clientNumber.toString(), // Ensure it's a string
//             gender: item.gender,
//             dateOfBilling: formattedDate,
//             timeOfBilling: formattedTime,
//             services: services,
//             products: [], // Add product transformation if needed
//             amountPaid: amountPaid,
//             amountPayable: item.amountPayable,
//             subTotal: item.subTotal,
//             totalAmount: item.totalAmount || item.amountPayable || 0,
//             paidDues: item.paidDues || 0,
//             advancedGiven: item.advancedGiven || 0,
//             preAdvanceUsed: item.preAdvanceUsed || 0,
//             useMembership: useMembership || false,
//             usePackage: usePackage || false,
//             membershipUniqueIds: [...new Set(membershipUniqueIds)], // Remove duplicates
//             packageUniqueIds: [...new Set(packageUniqueIds)], // Remove duplicates
//             giveRewardPoints: item.giveRewardPoints || false,
//             taxes: item.taxes || {
//               PGST: 0,
//               SGST: 0,
//               taxType: "Inclusive"
//             },
//             coupon: item.coupon || {
//               couponCode: "",
//               couponId: null,
//               discountAmount: 0
//             },
//             discount: {
//               discountType: item.discount?.discountType || "%",
//               discount: item.discount?.discount || ""
//             },
//             branchDetails: activeBranchId,
//             availability: true,
//             // createdAt: new Date().toISOString(),
//             // updatedAt: new Date().toISOString()
//           };
//         });

//         setUploadedData(formattedData);
//       };
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };


//   const handleBulkUploadSubmit = async (e) => {
//     e.preventDefault();
//     if (!uploadedData) {
//       setShowMessage({ message: 'Please select a valid file', messageType: 'error' });
//       return;
//     }
//     try {
//       setShowLoader(true);
//       const res = await createManyBills(
//         activeBranchId,
//         JSON.stringify({ bulkData: uploadedData }),
//       );
//       if (res?.statusCode === 200) {
//         getData();
//         setShowMessage({
//           message: res.message || 'Bulk bill upload successful',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({
//           message: res.message || 'Bulk bill upload failed',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Bulk bill upload failed',
//         messageType: 'error',
//       });
//     } finally {
//       setShowLoader(false);
//       setIsBulkUploadModalOpen(false);
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const templateFileName = Book1Billing;
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = templateFileName;
//     a.download = 'billing_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };

//   const openBulkUploadModal = () => {
//     setIsBulkUploadModalOpen(true);
//   };

//   const closeBulkUploadModal = () => {
//     setIsBulkUploadModalOpen(false);
//   };

//   // Rest of your existing functions...
//   const getPaymentMethods = () => {
//     if (billType === 'Wallet') {
//       return filterPaymentMethods.filter(method => method.value !== 'Wallet');
//     }
//     return filterPaymentMethods;
//   };

//   const filterOptions = [
//     {
//       title: 'Gender',
//       items: filterGenderWise,
//     },
//     {
//       title: 'Ratings',
//       items: filterRatings,
//     },
//     {
//       title: 'Payment Method',
//       items: getPaymentMethods(),
//     },
//     {
//       title: 'Services',
//       items: services.map((service) => ({
//         value: service._id,
//         label: service.serviceName,
//         gender: service.gender,
//       })),
//     },
//     {
//       title: 'Products',
//       items: products.map((product) => ({
//         value: product._id,
//         label: product.productName,
//         gender: product.gender,
//       })),
//     },
//     {
//       title: 'Service Providers',
//       items: serviceProviders.map((provider) => ({
//         value: provider._id,
//         label: provider.name,
//         gender: provider.gender,
//       })),
//     },
//     // {
//     //   title: 'Dues',
//     //   items: [
//     //     { value: 'hasDues', label: 'Show only bills with dues' }
//     //   ]
//     // }
//   ];

//   // const handleFilterChange = (selectedValues) => {
//   //   const serviceIds = selectedValues.filter(val =>
//   //     services.some(service => service._id === val)
//   //   );
//   //   const productIds = selectedValues.filter(val =>
//   //     products.some(product => product._id === val)
//   //   );
//   //   const providerIds = selectedValues.filter(val =>
//   //     serviceProviders.some(provider => provider._id === val)
//   //   );
//   //   const genderFilters = selectedValues.filter(val =>
//   //     filterGenderWise.some(opt => opt.value === val)
//   //   );
//   //   const ratingFilters = selectedValues.filter(val =>
//   //     filterRatings.some(opt => opt.value === val)
//   //   );
//   //   const paymentFilters = selectedValues.filter(val =>
//   //     getPaymentMethods().some(opt => opt.value === val)
//   //   );

//   //   const dues = selectedValues.includes('hasDues');

//   //   dispatch(setBillingFilter({
//   //     selectedGenderBy: genderFilters,
//   //     selectedRatingBy: ratingFilters,
//   //     selectedPaymentMethods: paymentFilters,
//   //     selectedServices: serviceIds,
//   //     selectedServiceProviders: providerIds,
//   //     selectedProducts: productIds,
//   //     page: 1
//   //   }));
//   // };
//   // ✅ Modified filter change handler
//   const handleFilterChange = (selectedValues) => {
//     const serviceIds = selectedValues.filter(val =>
//       services.some(service => service._id === val)
//     );
//     const productIds = selectedValues.filter(val =>
//       products.some(product => product._id === val)
//     );
//     const providerIds = selectedValues.filter(val =>
//       serviceProviders.some(provider => provider._id === val)
//     );
//     const genderFilters = selectedValues.filter(val =>
//       filterGenderWise.some(opt => opt.value === val)
//     );
//     const ratingFilters = selectedValues.filter(val =>
//       filterRatings.some(opt => opt.value === val)
//     );
//     const paymentFilters = selectedValues.filter(val =>
//       getPaymentMethods().some(opt => opt.value === val)
//     );

//     const dues = selectedValues.includes('hasDues');

//     dispatch(setBillingFilter({
//       selectedGenderBy: genderFilters,
//       selectedRatingBy: ratingFilters,
//       selectedPaymentMethods: paymentFilters,
//       selectedServices: serviceIds,
//       selectedServiceProviders: providerIds,
//       selectedProducts: productIds,
//       dues,
//       page: 1
//     }));

//     // ✅ Auto-reset when filters change
//     resetCheckedStates();
//   };

//   const hasActiveFilters = () => {
//     return (
//       search ||
//       startDate ||
//       endDate ||
//       selectedSortBy.length > 0 ||
//       selectedGenderBy.length > 0 ||
//       selectedRatingBy.length > 0 ||
//       selectedPaymentMethods.length > 0 ||
//       selectedServices.length > 0 ||
//       selectedServiceProviders.length > 0 ||
//       selectedProducts.length > 0 ||
//       dues
//     );
//   };

//   const getData = async (isFiltered = false) => {

//     // Always use the current page value from Redux state, not a hardcoded value
//     const queryParams = {
//       limit: isFiltered ? 10000 : limit,
//       page: isFiltered ? 1 : page, // Use current page from state
//       billType,
//       sortValue,
//       ...(search && { searchValue: search.trim() }),
//       ...(startDate && { startDate: startDate.trim() }),
//       ...(endDate && { endDate: endDate.trim() }),
//       ...(selectedSortBy.length > 0 && { sortBy: selectedSortBy.join(',') }),
//       ...(selectedGenderBy.length > 0 && { gender: selectedGenderBy.join(',') }),
//       ...(selectedRatingBy.length > 0 && { ratings: selectedRatingBy.join(',') }),
//       ...(selectedPaymentMethods.length > 0 && { paymentMethod: selectedPaymentMethods.join(',') }),
//       ...(selectedServices.length > 0 && { services: selectedServices.join(',') }),
//       ...(selectedServiceProviders.length > 0 && { staff: selectedServiceProviders.join(',') }),
//       ...(selectedProducts.length > 0 && { products: selectedProducts.join(',') }),
//       ...(dues && { dues: true }),
//     };

//     const queryString = Object.entries(queryParams)
//       .filter(([_, value]) => value !== undefined && value !== '')
//       .map(([key, value]) => `${key}=${value}`)
//       .join('&');

//     try {
//       setShowLoader(true);
//       const res = await fetchAllBillings(activeBranchId, `?${queryString}`);

//       if (res.statusCode === 200) {
//         if (isFiltered) {
//           setFullFilteredData(res.data || []);
//           setTotalFilteredCount(res.data?.length || 0);
//           const startIndex = (page - 1) * limit;
//           const endIndex = startIndex + limit;
//           setFilteredData(res.data.slice(startIndex, endIndex) || []);
//           setAllFilteredDataForSelection(res.data || []);
//         } else {
//           setData(res.data || []);
//           setAllFilteredDataForSelection(res.data || []);
//           setFilteredData(res.data || []);
//           setTotalFilteredCount(res.totalCount || 0);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   useEffect(() => {
//     const filtersActive = hasActiveFilters();
//     getData(filtersActive);

//     if (!filtersActive) {
//       setIsModalOpen(false);
//     }
//   }, [
//     activeBranchId,
//     billType,
//     limit,
//     page, // This dependency will trigger getData when page changes
//     debouncedSearch,
//     startDate,
//     endDate,
//     selectedSortBy,
//     sortValue,
//     selectedGenderBy,
//     selectedRatingBy,
//     selectedPaymentMethods,
//     selectedServices,
//     selectedServiceProviders,
//     selectedProducts,
//     dues,
//     clear
//   ]);

//   // useEffect(() => {
//   //   if (startDate && endDate && fullFilteredData.length > 0) {
//   //     const startIndex = (page - 1) * limit;
//   //     const endIndex = startIndex + limit;
//   //     setFilteredData(fullFilteredData.slice(startIndex, endIndex));
//   //     setTotalFilteredCount(fullFilteredData.length);
//   //   }
//   // }, [page, limit, startDate, endDate, fullFilteredData]);

//   useEffect(() => {
//     const totals = calculatePageTotals(filteredData);
//     setPageTotals(totals);
//   }, [filteredData]);

//   const calculatePageTotals = (currentPageData) => {
//     const totalAmount = currentPageData.reduce((acc, item) => acc + (item.amountPayable || 0), 0);
//     const amountPaid = currentPageData.reduce((acc, item) => {
//       if (Array.isArray(item.amountPaid)) {
//         const totalPaid = item.amountPaid.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
//         return acc + totalPaid;
//       }
//       return acc;
//     }, 0);
//     const paidDues = currentPageData.reduce((acc, item) => acc + (item.paidDues || 0), 0);

//     return { totalAmount, amountPaid, paidDues: isNaN(paidDues) ? 0 : paidDues };
//   };

//   const handleLimitChange = (e) => {
//     console.log(e.target.value, 'pagevalue')
//     dispatch(setBillingLimit(e.target.value));
//   };

//   const handleOnExport = () => {
//     const exportData = startDate && endDate ? fullFilteredData : data;
//     if (!Array.isArray(exportData)) {
//       console.error('Data is not an array or is undefined');
//       return;
//     }

//     const selectedFields = [
//       'clientName', 'clientNumber', 'gender', 'useMembership', 'dateOfBilling', 'timeOfBilling',
//       'subTotal', 'totalAmount', 'amountPayable', 'paidDues', 'advancedGiven', 'preAdvanceUsed',
//       'ratings',
//     ];

//     const flattenedData = exportData.map((item) => {
//       const flattenedItem = {};
//       selectedFields.forEach((field) => {
//         if (item.hasOwnProperty(field)) {
//           flattenedItem[field] = item[field];
//         }
//       });
//       if (Array.isArray(item.amountPaid)) {
//         flattenedItem.amountPaid = item.amountPaid.reduce((total, item) => total + parseFloat(item.amount), 0);
//       }
//       if (Array.isArray(item.services)) {
//         flattenedItem.serviceName = item.services.map(serviceItem => serviceItem.serviceName).join(', ');
//         flattenedItem.serviceProviders = item.services.map(serviceItem => serviceItem.serviceProvider?.name || '').join(', ');
//       }
//       if (Array.isArray(item.products)) {
//         flattenedItem.productName = item.products.map(productItem => productItem.productName).join(', ');
//         flattenedItem.productProvider = item.products.map(productItem => productItem.providerStaff?.name || '').join(', ');
//       }
//       return flattenedItem;
//     });

//     let wb = XLSX.utils.book_new();
//     let ws = XLSX.utils.json_to_sheet(flattenedData);
//     XLSX.utils.book_append_sheet(wb, ws, 'Bills');
//     XLSX.writeFile(wb, 'Bills.xlsx');
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const handleDateRangeSelected = (startDate, endDate) => {
//     dispatch(setBillingFilter({ startDate, endDate, page: 1 }));
//     setClear(true);
//     setIsModalOpen(false);
//   };

//   // ✅ RESET FUNCTION - Called when dialogs close or filters change
//   const resetCheckedStates = useCallback(() => {
//     setCheckedClients([]);
//     setIsAllChecked(false);
//     setSelectedTemplate(null);
//     setTemplateVariables({});
//     setSendError(null);
//     setValidationError('');
//   }, []);

//   const handleManualReset = () => {
//     resetCheckedStates();
//   };

//   // ✅ MODIFY search handler ko preserve selection
//   const handleSearchChange = (e) => {
//     dispatch(setBillingFilter({ search: e.target.value, page: 1 }));
//     // Selection preserve rahega, automatic reset nahi hoga
//   };

//   // ✅ Reset when WhatsApp dialog closes
//   useEffect(() => {
//     if (!openWhatsAppDialog && !openConfirmationDialog) {
//       resetCheckedStates();
//     }
//   }, [openWhatsAppDialog, openConfirmationDialog, resetCheckedStates]);

//   // ✅ Reset when filters change
//   // useEffect(() => {
//   //   resetCheckedStates();
//   // }, [
//   //   search, startDate, endDate, selectedSortBy, selectedGenderBy,
//   //   selectedRatingBy, selectedPaymentMethods, selectedServices,
//   //   selectedServiceProviders, selectedProducts, dues,
//   //   resetCheckedStates
//   // ]);

//   const showSnackbar = (message, severity = 'info') => {
//     setSnackbar({ open: true, message, severity });
//   };

//   // Validate phone numbers
//   const validatePhoneNumbers = (clients) => {
//     const invalidNumbers = clients.filter(client => {
//       const number = client.clientNumber.toString().replace(/\D/g, '');
//       return number.length < 10 || number.length > 15;
//     });

//     if (invalidNumbers.length > 0) {
//       return `Invalid phone numbers found: ${invalidNumbers.map(c => c.clientNumber).join(', ')}`;
//     }
//     return null;
//   };

//   // Prepare WhatsApp payload with proper variable segregation
//   const prepareWhatsAppPayload = (template, clients) => {
//     if (!template || !clients || clients.length === 0) {
//       throw new Error('Template or clients data is missing');
//     }

//     const numbers = clients.map((client) => {
//       const number = client.clientNumber.toString().replace(/\D/g, '');
//       return number.startsWith('91') ? number : `${number}`;
//     });

//     const payload = {
//       numbers: numbers,
//       template_name: template.name,
//     };

//     // Separate body and button variables
//     const bodyVariables = {};
//     const buttonVariables = {};

//     template.variables.forEach((variable, index) => {
//       const varKey = `var_${index + 1}`;
//       const value = template.variableValues?.[varKey] || '';

//       if (variable.toLowerCase().includes('button')) {
//         const buttonIndex = variable.split('_')[1] || (index + 1);
//         buttonVariables[`button${buttonIndex}`] = value;
//       } else {
//         const bodyIndex = variable.split('_')[1] || (index + 1);
//         bodyVariables[`var${bodyIndex}`] = value;
//       }
//     });

//     // Merge body and button variables into payload
//     Object.assign(payload, bodyVariables, buttonVariables);

//     return payload;
//   };

//   // Updated WhatsApp sending function with validation
//   const handleSendBulkWhatsApp = async () => {
//     try {
//       // Validation checks
//       if (!selectedTemplate) {
//         throw new Error('Please select a WhatsApp template');
//       }

//       if (!checkedClients || checkedClients.length === 0) {
//         throw new Error('No clients selected for WhatsApp messaging');
//       }

//       const phoneValidationError = validatePhoneNumbers(checkedClients);
//       if (phoneValidationError) {
//         throw new Error(phoneValidationError);
//       }

//       // Validate template variables
//       const missingVariables = selectedTemplate.variables.filter((variable, index) => {
//         const varKey = `var_${index + 1}`;
//         return !selectedTemplate.variableValues?.[varKey]?.trim();
//       });

//       if (missingVariables.length > 0) {
//         throw new Error(`Please fill all template variables: ${missingVariables.join(', ')}`);
//       }

//       // Prepare payload
//       const payload = prepareWhatsAppPayload(selectedTemplate, checkedClients);

//       console.log('Final Payload:', payload);

//       // Start sending process
//       setIsSending(true);
//       setSendProgress(0);
//       setSendError(null);

//       // Simulate progress updates
//       const progressInterval = setInterval(() => {
//         setSendProgress(prev => {
//           if (prev >= 90) {
//             clearInterval(progressInterval);
//             return prev;
//           }
//           return prev + 10;
//         });
//       }, 300);

//       // API call
//       const res = await sendBulkWhatsApp(payload, activeBranchId);

//       clearInterval(progressInterval);
//       setSendProgress(100);

//       if (res.statusCode === 200) {
//         showSnackbar(`WhatsApp messages sent successfully to ${checkedClients.length} clients`, 'success');

//         // ✅ Reset everything after success
//         setTimeout(() => {
//           resetCheckedStates();
//           setOpenConfirmationDialog(false);
//           setOpenWhatsAppDialog(false);
//           setIsSending(false);
//           setSendProgress(0);
//         }, 2000);

//       } else {
//         throw new Error(res.message || 'Failed to send WhatsApp messages');
//       }
//     } catch (error) {
//       console.error('WhatsApp sending error:', error);
//       setSendError(error.message);
//       showSnackbar(error.message, 'error');
//       setIsSending(false);
//       setSendProgress(0);
//     }
//   };

//   // ✅ Modified Template Selection Dialog onClose
//   const handleTemplateDialogClose = () => {
//     if (!isSending) {
//       setOpenWhatsAppDialog(false);
//       resetCheckedStates();
//     }
//   };

//   // ✅ Modified Confirmation Dialog onClose
//   const handleConfirmationDialogClose = () => {
//     if (!isSending) {
//       setOpenConfirmationDialog(false);
//       // Don't reset checked clients here if user just cancels confirmation
//       // but keep template selection for next time
//     }
//   };

//   // Template confirmation handler
//   const handleTemplateConfirm = (templateWithVariables) => {
//     console.log('Template confirmed:', templateWithVariables);

//     // Validate template variables before confirmation
//     const missingVariables = templateWithVariables.variables.filter((variable, index) => {
//       const varKey = `var_${index + 1}`;
//       return !templateWithVariables.variableValues?.[varKey]?.trim();
//     });

//     if (missingVariables.length > 0) {
//       setValidationError(`Please fill all required variables: ${missingVariables.join(', ')}`);
//       return;
//     }

//     setSelectedTemplate(templateWithVariables);
//     setValidationError('');
//     setOpenConfirmationDialog(true);
//   };

//   const fetchWhatsAppTemplates = async () => {
//     try {
//       setShowLoader(true);
//       const res = await getWhatsAppTemplates();
//       console.log(res, 'resssssssss');

//       if (res.status === "success" && res.data) {
//         // Filter only approved templates - nested structure ke according
//         const approvedTemplates = res.data.filter(template => {
//           // Check if template has languages array and first language has APPROVED status
//           return template.languages &&
//             template.languages.length > 0 &&
//             template.languages[0].status === "APPROVED";
//         });

//         console.log('Approved Templates:', approvedTemplates);
//         setTemplates(approvedTemplates);
//         setOpenWhatsAppDialog(true);
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to fetch templates',
//           messageType: 'error'
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching templates:', error);
//       setShowMessage({
//         message: 'Failed to fetch templates',
//         messageType: 'error'
//       });
//     } finally {
//       setShowLoader(false);
//     }
//   };


//   console.log(templates, 'templates')
//   return (
//     <>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0px 1.5rem 30px' }}>
//         {/* Show per page - Left side */}
//         <div style={{ width: '100px', marginBottom: '20px' }}>
//           <InputLabel>Show per page</InputLabel>
//           <Select
//             style={{
//               borderRadius: '7px',
//               border: '0.5px solid #6174DD',
//               padding: '4px 12px',
//               background: '#FFF',
//               height: '40px',
//               width: '100%',
//             }}
//             value={limit}
//             onChange={handleLimitChange}
//           >
//             {[10, 50, 100, 200].map((value) => (
//               <MenuItem key={value} value={value}>
//                 {value}
//               </MenuItem>
//             ))}
//           </Select>
//         </div>

//         {/* Right side buttons: Search, Filter, Download */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
//           {/* Search */}
//           <div style={{ width: '130px', marginBottom: '25px' }} onClick={() => document.getElementById('search-input').focus()}>
//             <InputLabel>Search</InputLabel>
//             <div className="search-input" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
//               <img src={SearchImg} alt="" style={{ verticalAlign: 'middle' }} />
//               {/* <input
//                 id="search-input"
//                 style={{ flex: 1, padding: '4px 2px', borderRadius: '7px', width: '100%' }}
//                 type="text"
//                 placeholder=""
//                 value={search}
//                 onChange={(e) => dispatch(setBillingFilter({ search: e.target.value }))}
//               /> */}
//               <input
//                 id="search-input"
//                 style={{ flex: 1, padding: '4px 2px', borderRadius: '7px', width: '100%' }}
//                 type="text"
//                 placeholder="Search clients..."
//                 value={search}
//                 onChange={handleSearchChange} // ✅ Modified handler use karein
//               />
//               {search && (
//                 <IconButton
//                   onClick={() => {
//                     dispatch(setBillingFilter({ search: '' }));
//                     setClear(false);
//                   }}
//                   style={{ padding: 1 }}
//                 >
//                   <MdClear style={{ color: '#000', marginRight: '-0.1rem', marginTop: '0.1rem', fontSize: '1.1rem' }} />
//                 </IconButton>
//               )}
//             </div>
//           </div>

//           {/* Filter */}
//           <div style={{ width: '150px' }}>
//             <FilterBillPage
//               options={filterOptions}
//               value={[
//                 ...selectedGenderBy,
//                 ...selectedRatingBy,
//                 ...selectedPaymentMethods,
//                 ...selectedServices,
//                 ...selectedServiceProviders,
//                 ...selectedProducts,
//               ]}
//               onChange={handleFilterChange}
//               placeholder="Filters"
//               selectedStartDate={startDate}
//               selectedEndDate={endDate}
//               onDateRangeSelected={(start, end) => {
//                 dispatch(setBillingFilter({ startDate: start, endDate: end }));
//               }}
//               onClearDate={() => {
//                 dispatch(setBillingFilter({ startDate: '', endDate: '' }));
//               }}
//               loadingServices={loadingServices}
//               loadingProviders={loadingProviders}
//               hasDues={dues}
//               onToggleDues={(newDuesValue) => {
//                 dispatch(setBillingFilter({ dues: newDuesValue, page: 1 }));
//               }}
//               products={products} // Add this line to pass products
//               onProductSelectionChange={(selectedProductIds) => {
//                 dispatch(setBillingFilter({ selectedProducts: selectedProductIds, page: 1 }));
//               }}
//             />
//           </div>

//           {/* Bulk Upload Button */}
//           {/* <div style={{ width: '150px' }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={openBulkUploadModal}
//               sx={{
//                 height: '40px',
//                 width: '100%',
//                 padding: '0.3rem',
//                 '&:hover': { background: '#6174DD' },
//               }}
//             >
//               Bulk Upload
//             </Button>
//           </div> */}

//           {/* Download Button */}
//           {
//             !hideDownloadButton && (
//               <div style={{ width: '70px' }}>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   title="Download Bills"
//                   sx={{
//                     height: '40px',
//                     width: '100%',
//                     padding: '0.3rem',
//                     '&:hover': { background: '#6174DD' },
//                   }}
//                   onClick={handleOnExport}
//                 >
//                   <FaDownload style={{ height: '1.6rem', fontSize: '1.2rem' }} />
//                 </Button>
//               </div>
//             )
//           }
//         </div>
//       </div>

//       {showLoader ? (
//         <ShowLoader />
//       ) : (
//         <Box>
//           {filteredData && filteredData.length > 0 ? (
//             <Grid container spacing={3}>
//               <Grid item xs={12} lg={12}>
//                 {/* <FieldData
//                   data={filteredData}
//                   setData={setData}
//                   getData={getData}
//                   billType={billType}
//                   ownerId={ownerId}
//                   allClient={allClient}
//                   checkedClients={checkedClients}
//                   setCheckedClients={setCheckedClients}
//                 /> */}
//                 <FieldData
//                   data={filteredData} // Current page data for display
//                   allData={hasActiveFilters() ? fullFilteredData : data} // All data for selection
//                   setData={setData}
//                   getData={getData}
//                   billType={billType}
//                   ownerId={ownerId}
//                   allClient={allClient}
//                   checkedClients={checkedClients}
//                   setCheckedClients={setCheckedClients}
//                   hasActiveFilters={hasActiveFilters()}
//                   isAllChecked={isAllChecked}
//                   setIsAllChecked={setIsAllChecked}

//                 />

//               </Grid>
//             </Grid>
//           ) : (
//             <div style={{ marginTop: '2rem' }} variant="h6" align="center">
//               No data found
//             </div>
//           )}
//         </Box>
//       )}

//       <Box display={'flex'} justifyContent={'flex-end'}>
//         <Pagination
//           count={hasActiveFilters() ? Math.ceil(totalFilteredCount / limit) : page + 1}
//           page={page}
//           color="primary"
//           onChange={(e, newPage) => {
//             dispatch(setBillingPage(newPage));
//             // getData(hasActiveFilters());
//           }}
//         />
//       </Box>

//       <Box
//         display="flex"
//         flexDirection="column"
//         style={{
//           width: '100%',
//           marginLeft: '0.5rem',
//           marginTop: '1rem',
//           padding: '1rem',
//           boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//           borderRadius: '8px',
//         }}
//       >
//         <Typography variant="h6" fontWeight="600" gutterBottom>
//           Amount as per Page
//         </Typography>

//         <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Amount:</strong> ₹ {pageTotals.totalAmount}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Paid:</strong> ₹ {pageTotals.amountPaid}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Pending:</strong> ₹ {pageTotals.paidDues}
//           </Typography>
//         </Box>
//       </Box>

//       {/* Bulk Upload Modal */}
//       <Dialog open={isBulkUploadModalOpen} onClose={closeBulkUploadModal}>
//         <DialogTitle>Bulk Upload Bills</DialogTitle>
//         <form onSubmit={handleBulkUploadSubmit}>
//           <DialogContent>
//             <input
//               type="file"
//               accept=".xlsx, .xls"
//               onChange={handleFileChange}
//             />
//             {showLoader && <ShowLoader />}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={closeBulkUploadModal}>Cancel</Button>
//             {/* <Button 
//               variant="outlined"
//               color="primary"
//               onClick={downloadExcelTemplate}
//               startIcon={<ArrowCircleDownIcon />}
//             >
//               Sample Download
//             </Button> */}
//             <Button type="submit" variant="contained" color="primary">
//               Submit
//             </Button>
//           </DialogActions>
//         </form>
//       </Dialog>

//       <DateRangeInputs
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         onDateRangeSelected={handleDateRangeSelected}
//         selectedEndDate={endDate}
//         selectedStartDate={startDate}
//       />
//       {/* Selected Clients Card */}
//       {/* {checkedClients.length > 0 && (
//         <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }} style={{ marginTop: '30px', width: '100%', height: '95px' }}>
//           <CardContent>
//             <Box display="flex" justifyContent="space-between" alignItems="center" padding={'5px'}>
//               <Box style={{ padding: '5px' }}>
//                 <Typography variant="h6" gutterBottom>
//                   📱 Ready to Send WhatsApp
//                 </Typography>
//                 <Box display="flex" gap={2} alignItems="center" marginTop={'10px'}>
//                   <Chip
//                     label={`${checkedClients.length} clients selected`}
//                     color="primary"
//                     variant="outlined"
//                   />
//                   <Typography variant="body2" color="text.secondary">
//                     {checkedClients.length} clients will receive WhatsApp messages
//                   </Typography>
//                 </Box>
//               </Box>
//               <Button
//                 variant="contained"
//                 startIcon={<WhatsAppIcon />}
//                 onClick={fetchWhatsAppTemplates}
//                 sx={{
//                   background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
//                   borderRadius: '8px',
//                   px: 3,
//                   '&:hover': {
//                     background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
//                   }
//                 }}
//               >
//                 Send Bulk WhatsApp
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )} */}
//       {checkedClients.length > 0 && (
//         <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }} style={{ marginTop: '30px', width: '100%', height: '95px' }}>
//           <CardContent>
//             <Box display="flex" justifyContent="space-between" alignItems="center" padding={'5px'}>
//               <Box style={{ padding: '5px' }}>
//                 <Typography variant="h6" gutterBottom>
//                   📱 Ready to Send WhatsApp
//                 </Typography>
//                 <Box display="flex" gap={2} alignItems="center" marginTop={'10px'}>
//                   <Chip
//                     label={`${checkedClients.length} clients selected`}
//                     color="primary"
//                     variant="outlined"
//                   />
//                   <Button
//                     variant="outlined"
//                     color="secondary"
//                     onClick={handleManualReset}
//                     size="small"
//                   >
//                     Clear Selection
//                   </Button>
//                 </Box>
//               </Box>
//               <Button
//                 variant="contained"
//                 startIcon={<WhatsAppIcon />}
//                 onClick={fetchWhatsAppTemplates}
//                 sx={{
//                   background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
//                   borderRadius: '8px',
//                   px: 3,
//                   '&:hover': {
//                     background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
//                   }
//                 }}
//               >
//                 Send Bulk WhatsApp
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {/* Template Selection Dialog */}
//       {/* <TemplateSelectionDialog
//         open={openWhatsAppDialog}
//         templates={templates}
//         onClose={() => {
//           if (!isSending) {
//             setOpenWhatsAppDialog(false);
//             setSelectedTemplate(null);
//             setSendError(null);
//             setValidationError('');
//           }
//         }}
//         onConfirm={handleTemplateConfirm}
//         isSending={isSending}
//         sendProgress={sendProgress}
//         sendError={sendError}
//         validationError={validationError}
//       /> */}
//       <TemplateSelectionDialog
//         open={openWhatsAppDialog}
//         templates={templates}
//         onClose={handleTemplateDialogClose} // Use modified handler
//         onConfirm={handleTemplateConfirm}
//         isSending={isSending}
//         sendProgress={sendProgress}
//         sendError={sendError}
//         validationError={validationError}
//         setSendError={setSendError}
//       />

//       {/* Confirmation Dialog */}
//       <Dialog
//         open={openConfirmationDialog}
//         onClose={handleConfirmationDialogClose}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
//           <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
//             <WhatsAppIcon color="success" />
//             <Typography variant="h6">
//               {isSending ? `Sending... ${sendProgress}%` : 'Confirm WhatsApp Send'}
//             </Typography>
//           </Box>
//           {isSending && (
//             <LinearProgress
//               variant="determinate"
//               value={sendProgress}
//               sx={{ mt: 1 }}
//             />
//           )}
//         </DialogTitle>

//         <DialogContent>
//           {sendError && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {sendError}
//             </Alert>
//           )}

//           <Alert severity="info" sx={{ mb: 2 }}>
//             You're about to send WhatsApp messages to {checkedClients.length} clients
//           </Alert>

//           {selectedTemplate && (
//             <Box>
//               <Typography variant="subtitle2" gutterBottom>
//                 Template: <strong>{selectedTemplate.name}</strong>
//               </Typography>

//               <Box mt={2}>
//                 <Typography variant="body2" color="text.secondary" gutterBottom>
//                   Message Preview:
//                 </Typography>
//                 <Card variant="outlined" sx={{ p: 2, bgcolor: '#fafafa' }}>
//                   <Typography variant="body2" whiteSpace="pre-wrap">
//                     {selectedTemplate.bodyText || 'No message content'}
//                   </Typography>
//                 </Card>
//               </Box>

//               {selectedTemplate.variables.length > 0 && (
//                 <Box mt={2}>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Variables to be sent:
//                   </Typography>
//                   {selectedTemplate.variables.map((variable, index) => (
//                     <Chip
//                       key={variable}
//                       label={`${variable}: ${selectedTemplate.variableValues?.[`var_${index + 1}`] || 'Not set'}`}
//                       size="small"
//                       sx={{ mr: 1, mb: 1 }}
//                       variant="outlined"
//                       color={selectedTemplate.variableValues?.[`var_${index + 1}`] ? "success" : "default"}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button
//             onClick={handleConfirmationDialogClose}
//             variant="outlined"
//             sx={{ borderRadius: '6px' }}
//             disabled={isSending}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSendBulkWhatsApp}
//             variant="contained"
//             startIcon={<WhatsAppIcon />}
//             disabled={isSending}
//             sx={{
//               background: isSending
//                 ? '#ccc'
//                 : 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
//               borderRadius: '6px',
//               px: 3,
//               '&:hover': isSending ? {} : {
//                 background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
//               },
//               '&:disabled': {
//                 background: '#ccc'
//               }
//             }}
//           >
//             {isSending ? `Sending... ${sendProgress}%` : `Send to ${checkedClients.length} Clients`}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//     </>
//   );
// };

// export default AllBillings;

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { forwardRef, useImperativeHandle } from 'react'; // add to your React import line
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  CardContent,
  Alert,
  LinearProgress,
  Snackbar,
} from '@mui/material';
import * as XLSX from 'xlsx';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
import FieldData from './FieldData';
import SearchImg from '../../assets/search.svg';
import { useMain } from '../hooks/useMain';
import { IoStar } from "react-icons/io5";
import { FaDownload, FaFilePdf, FaFileExcel } from "react-icons/fa";
import { MdClear } from "react-icons/md";
import { setBillingFilter, setBillingPage, setBillingLimit, resetBillingSearchAndFilters, toggleDuesFilter } from '../../redux/slices/AllBillingSlice';
import FilterBillPage from "./FilterBillPage";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import Book1Billing from '../../assets/excel/Book1Bill.xlsx';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TemplateSelectionDialog from './Templates/TemplateSelectionDialog';
import { Card } from 'reactstrap';
import { padding } from '@mui/system';

const filterGenderWise = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
];

const filterRatings = [
  { value: 4, label: <>4 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
  { value: 3, label: <>3 <IoStar style={{ marginBottom: '0.2rem' }} /> & above</> },
];

const filterPaymentMethods = [
  { value: 'Cash', label: 'Cash' },
  { value: 'Wallet', label: 'Wallet' },
  { value: 'Credit/Debit Card', label: 'Credit/Debit Card' },
  { value: 'Gpay', label: 'GPay' },
  { value: 'Paytm', label: 'Paytm' },
  { value: 'PhonePe', label: 'PhonePe' },
];


const AllBillings = forwardRef(({ billType }, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const billingFilters = useSelector(state => state.allBilling);
  const {
    limit,
    page,
    search,
    sortValue,
    startDate,
    endDate,
    selectedSortBy,
    selectedGenderBy,
    selectedRatingBy,
    selectedPaymentMethods,
    selectedServices,
    selectedServiceProviders,
    selectedProducts,
    dues,
    availability
  } = billingFilters;

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [clear, setClear] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [services, setServices] = useState([]);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [products, setProducts] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [loadingProviders, setLoadingProviders] = useState(false);
  const [pageTotals, setPageTotals] = useState({ totalAmount: 0, amountPaid: 0, paidDues: 0 });
  const [fullFilteredData, setFullFilteredData] = useState([]);
  const [totalFilteredCount, setTotalFilteredCount] = useState(0);
  const [ownerId, setOwnerId] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState(search); //debounce state
  const [allClient, setAllClient] = useState([])

  const [allFilteredDataForSelection, setAllFilteredDataForSelection] = useState([]);
  const [checkedClients, setCheckedClients] = useState([]);
  // Add isAllChecked state in AllBilling component
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [openWhatsAppDialog, setOpenWhatsAppDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateVariables, setTemplateVariables] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(0);
  const [sendError, setSendError] = useState(null);
  const [validationError, setValidationError] = useState('');
  const [hideDownloadButton, setHideDownloadButton] = useState(true)
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { fetchAllBillings, activeBranchId, getBranch, createManyBills, sendBulkWhatsApp, getWhatsAppTemplates, setShowMessage } = useMain();

  const handleDownloadBulkPdf = () => {
    if (checkedClients.length === 0) {
      setShowMessage({ message: 'No bills selected for bulk PDF download.', messageType: 'error' });
      return;
    }

    const billIds = checkedClients.map(item => item._id);

    navigate('/bulkbillgenerator', {
      state: {
        billIds,
        billType: billType === 'Wallet' ? 'Wallet' : 'Bill',
      },
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 1000ms delay

    return () => {
      clearTimeout(handler); // agar user typing continue kare to purana timer clear hoga
    };
  }, [search]);

  const fetchServicesAndStaff = async (activeBranchId) => {
    try {
      const res = await getBranch(activeBranchId);
      const data = res?.data;
      return {
        services: data?.services || [],
        staff: data?.staffs || [],
        products: data?.products || [],
        ownerId: data?.ownerId[0]?._id || "",
        allClient: data?.client || [],
        hideDownloadButton: data?.hideDownloadButton || false
      };
    } catch (error) {
      console.error("Error fetching services and staff:", error);
      return { services: [], staff: [], products: [] };
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoadingServices(true);
      setLoadingProviders(true);
      try {
        const { services, staff, products, ownerId, allClient, hideDownloadButton } = await fetchServicesAndStaff(activeBranchId);

        setServices(services);
        setServiceProviders(staff);
        setProducts(products);
        setOwnerId(ownerId);
        setAllClient(allClient)
        setHideDownloadButton(hideDownloadButton)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingServices(false);
        setLoadingProviders(false);
      }
    };
    fetchData();
  }, [activeBranchId]);

  useEffect(() => {
    dispatch(resetBillingSearchAndFilters());

    return () => dispatch(resetBillingSearchAndFilters());
  }, [dispatch]);

  // Bulk upload functions
  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target.result);
  //       const workbook = XLSX.read(data, { type: 'array' });
  //       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
  //       const jsonData = XLSX.utils.sheet_to_json(firstSheet);
  //       console.log(jsonData,'jsonDataaaa')
  //       setUploadedData(jsonData);
  //     };
  //     reader.readAsArrayBuffer(selectedFile);
  //   }
  // };


  //new code arpit
  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target.result);
  //       const workbook = XLSX.read(data, { type: 'array' });
  //       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
  //       const jsonData = XLSX.utils.sheet_to_json(firstSheet);

  //       // Transform the data to match your billing format
  //       const formattedData = jsonData.map((item, index) => {
  //         // Convert Excel date (numeric) to JavaScript Date object
  //         const excelDate = item.dateOfBilling;
  //         const jsDate = new Date((excelDate - 25569) * 86400 * 1000);

  //         // Format date as YYYY-MM-DD
  //         const formattedDate = jsDate.toISOString().split('T')[0];

  //         // Convert Excel time (fraction of day) to HH:MM:SS
  //         const excelTime = item.timeOfBilling;
  //         const hours = Math.floor(excelTime * 24);
  //         const minutes = Math.floor((excelTime * 24 - hours) * 60);
  //         const seconds = Math.floor(((excelTime * 24 - hours) * 60 - minutes) * 60);
  //         const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  //         // Initialize membership and package arrays
  //         const membershipUniqueIds = [];
  //         const packageUniqueIds = [];
  //         let useMembership = false;
  //         let usePackage = false;

  //         // Transform services data into proper array format
  //         const services = [];
  //         let serviceIndex = 0;
  //         while (item[`services[${serviceIndex}].serviceName`]) {
  //           // Handle service providers - convert to array if needed
  //           let serviceProviders = [];
  //           if (item[`services[${serviceIndex}].serviceProvider`]) {
  //             // If it's already an array, use it directly
  //             if (Array.isArray(item[`services[${serviceIndex}].serviceProvider`])) {
  //               serviceProviders = item[`services[${serviceIndex}].serviceProvider`];
  //             }
  //             // If it's a string (single provider), convert to array
  //             else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'string') {
  //               serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
  //             }
  //             // If it's an object, convert to array of objects
  //             else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'object') {
  //               serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
  //             }
  //           }

  //           // Handle membership for this service
  //           const serviceMembershipUniqueId = item[`services[${serviceIndex}].membershipUniqueId`] || "";
  //           const membershipApplied = !!serviceMembershipUniqueId;

  //           // Handle package for this service
  //           const servicePackageUniqueId = item[`services[${serviceIndex}].packageUniqueId`] || "";
  //           const packageApplied = !!servicePackageUniqueId;

  //           // Add to global membership/package tracking if exists
  //           if (serviceMembershipUniqueId) {
  //             membershipUniqueIds.push(serviceMembershipUniqueId);
  //             useMembership = true;
  //           }
  //           if (servicePackageUniqueId) {
  //             packageUniqueIds.push(servicePackageUniqueId);
  //             usePackage = true;
  //           }

  //           services.push({
  //             // _id: item[`services[${serviceIndex}]._id`] || `temp-${index}-${serviceIndex}`,
  //             service: item[`services[${serviceIndex}].service`],
  //             serviceName: item[`services[${serviceIndex}].serviceName`],
  //             serviceProvider: serviceProviders,
  //             category: item[`services[${serviceIndex}].category`] || "",
  //             price: item[`services[${serviceIndex}].price`] || 0,
  //             discount: item[`services[${serviceIndex}].discount`] || 0,
  //             discountType: item[`services[${serviceIndex}].discountType`] || "%",
  //             amount: item[`services[${serviceIndex}].amount`] || 0,
  //             quantity: item[`services[${serviceIndex}].quantity`] || 1,
  //             ...(serviceMembershipUniqueId && { membershipUniqueId: serviceMembershipUniqueId }),
  //             // ...(membershipApplied && { membershipApplied: membershipApplied }) ,
  //             ...(servicePackageUniqueId && { packageUniqueId: servicePackageUniqueId }),
  //             // packageApplied: packageApplied || false
  //           });
  //           serviceIndex++;
  //         }

  //         // Transform amountPaid data
  //         const amountPaid = [];
  //         let paymentIndex = 0;
  //         while (item[`amountPaid[${paymentIndex}].amount`]) {
  //           amountPaid.push({
  //             // _id: item[`amountPaid[${paymentIndex}]._id`] || `temp-pay-${index}-${paymentIndex}`,
  //             amount: item[`amountPaid[${paymentIndex}].amount`],
  //             paymentType: item[`amountPaid[${paymentIndex}].paymentType`]
  //           });
  //           paymentIndex++;
  //         }

  //         // Create the formatted bill object
  //         return {
  //           // _id: item._id || `temp-${index}`,
  //           // invoice: item.invoice,
  //           billType: item.billType || 'Bill',
  //           clientName: item.clientName,
  //           clientNumber: item.clientNumber.toString(), // Ensure it's a string
  //           gender: item.gender,
  //           dateOfBilling: formattedDate,
  //           timeOfBilling: formattedTime,
  //           services: services,
  //           products: [], // Add product transformation if needed
  //           amountPaid: amountPaid,
  //           amountPayable: item.amountPayable,
  //           subTotal: item.subTotal,
  //           totalAmount: item.totalAmount || item.amountPayable || 0,
  //           paidDues: item.paidDues || 0,
  //           advancedGiven: item.advancedGiven || 0,
  //           preAdvanceUsed: item.preAdvanceUsed || 0,
  //           useMembership: useMembership || false,
  //           usePackage: usePackage || false,
  //           membershipUniqueIds: [...new Set(membershipUniqueIds)], // Remove duplicates
  //           packageUniqueIds: [...new Set(packageUniqueIds)], // Remove duplicates
  //           giveRewardPoints: item.giveRewardPoints || false,
  //           taxes: item.taxes || {
  //             PGST: 0,
  //             SGST: 0,
  //             taxType: "Inclusive"
  //           },
  //           coupon: item.coupon || {
  //             couponCode: "",
  //             couponId: null,
  //             discountAmount: 0
  //           },
  //           discount: {
  //             discountType: item.discount?.discountType || "%",
  //             discount: item.discount?.discount || ""
  //           },
  //           branchDetails: activeBranchId,
  //           availability: true,
  //           // createdAt: new Date().toISOString(),
  //           // updatedAt: new Date().toISOString()
  //         };
  //       });

  //       setUploadedData(formattedData);
  //     };
  //     reader.readAsArrayBuffer(selectedFile);
  //   }
  // };
    const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);

        // Transform the data to match your billing format
        const formattedData = jsonData.map((item, index) => {
          // Convert Excel date (numeric) to JavaScript Date object
          // Safely handle date and time whether numeric or string
let formattedDate = "";
if (typeof item.dateOfBilling === "number") {
  const jsDate = new Date((item.dateOfBilling - 25569) * 86400 * 1000);
  formattedDate = jsDate.toISOString().split("T")[0];
} else if (typeof item.dateOfBilling === "string") {
  formattedDate = item.dateOfBilling;
}

let formattedTime = "";
if (typeof item.timeOfBilling === "number") {
  const totalSeconds = item.timeOfBilling * 24 * 60 * 60;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
} else if (typeof item.timeOfBilling === "string") {
  formattedTime = item.timeOfBilling;
}

          // Initialize membership and package arrays
          const membershipUniqueIds = [];
          const packageUniqueIds = [];
          let useMembership = false;
          let usePackage = false;

          // Transform services data into proper array format
          const services = [];
          let serviceIndex = 0;
          while (item[`services[${serviceIndex}].serviceName`]) {
            // Handle service providers - convert to array if needed
            let serviceProviders = [];
            if (item[`services[${serviceIndex}].serviceProvider`]) {
              // If it's already an array, use it directly
              if (Array.isArray(item[`services[${serviceIndex}].serviceProvider`])) {
                serviceProviders = item[`services[${serviceIndex}].serviceProvider`];
              }
              // If it's a string (single provider), convert to array
              else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'string') {
                serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
              }
              // If it's an object, convert to array of objects
              else if (typeof item[`services[${serviceIndex}].serviceProvider`] === 'object') {
                serviceProviders = [item[`services[${serviceIndex}].serviceProvider`]];
              }
            }

            // Handle membership for this service
            const serviceMembershipUniqueId = item[`services[${serviceIndex}].membershipUniqueId`] || "";
            const membershipApplied = !!serviceMembershipUniqueId;

            // Handle package for this service
            const servicePackageUniqueId = item[`services[${serviceIndex}].packageUniqueId`] || "";
            const packageApplied = !!servicePackageUniqueId;

            // Add to global membership/package tracking if exists
            if (serviceMembershipUniqueId) {
              membershipUniqueIds.push(serviceMembershipUniqueId);
              useMembership = true;
            }
            if (servicePackageUniqueId) {
              packageUniqueIds.push(servicePackageUniqueId);
              usePackage = true;
            }

            services.push({
              // _id: item[`services[${serviceIndex}]._id`] || `temp-${index}-${serviceIndex}`,
              service: item[`services[${serviceIndex}].service`],
              serviceName: item[`services[${serviceIndex}].serviceName`],
              serviceProvider: serviceProviders,
              category: item[`services[${serviceIndex}].category`] || "",
              price: item[`services[${serviceIndex}].price`] || 0,
              discount: item[`services[${serviceIndex}].discount`] || 0,
              discountType: item[`services[${serviceIndex}].discountType`] || "%",
              amount: item[`services[${serviceIndex}].amount`] || 0,
              quantity: item[`services[${serviceIndex}].quantity`] || 1,
              ...(serviceMembershipUniqueId && { membershipUniqueId: serviceMembershipUniqueId }),
              // ...(membershipApplied && { membershipApplied: membershipApplied }) ,
              ...(servicePackageUniqueId && { packageUniqueId: servicePackageUniqueId }),
              // packageApplied: packageApplied || false
            });
            serviceIndex++;
          }

          // Transform amountPaid data
          const amountPaid = [];
          let paymentIndex = 0;
          while (item[`amountPaid[${paymentIndex}].amount`]) {
            amountPaid.push({
              // _id: item[`amountPaid[${paymentIndex}]._id`] || `temp-pay-${index}-${paymentIndex}`,
              amount: item[`amountPaid[${paymentIndex}].amount`],
              paymentType: item[`amountPaid[${paymentIndex}].paymentType`]
            });
            paymentIndex++;
          }

          // Create the formatted bill object
          return {
            // _id: item._id || `temp-${index}`,
            // invoice: item.invoice,
            billType: item.billType || 'Bill',
            clientName: item.clientName,
            clientNumber: item.clientNumber.toString(), // Ensure it's a string
            gender: item.gender,
            dateOfBilling: formattedDate,
            timeOfBilling: formattedTime,
            services: services,
            products: [], // Add product transformation if needed
            amountPaid: amountPaid,
            amountPayable: item.amountPayable,
            subTotal: item.subTotal,
            totalAmount: item.totalAmount || item.amountPayable || 0,
            paidDues: item.paidDues || 0,
            advancedGiven: item.advancedGiven || 0,
            preAdvanceUsed: item.preAdvanceUsed || 0,
            useMembership: useMembership || false,
            usePackage: usePackage || false,
            membershipUniqueIds: [...new Set(membershipUniqueIds)], // Remove duplicates
            packageUniqueIds: [...new Set(packageUniqueIds)], // Remove duplicates
            giveRewardPoints: item.giveRewardPoints || false,
            taxes: item.taxes || {
              PGST: 0,
              SGST: 0,
              taxType: "Inclusive"
            },
            coupon: item.coupon || {
              couponCode: "",
              couponId: null,
              discountAmount: 0
            },
            discount: {
              discountType: item.discount?.discountType || "%",
              discount: item.discount?.discount || ""
            },
            branchDetails: activeBranchId,
            availability: true,
            // createdAt: new Date().toISOString(),
            // updatedAt: new Date().toISOString()
          };
        });
        console.log(formattedData,'formatedData')
        setUploadedData(formattedData);
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };


  const handleBulkUploadSubmit = async (e) => {
    e.preventDefault();
    if (!uploadedData) {
      setShowMessage({ message: 'Please select a valid file', messageType: 'error' });
      return;
    }
    try {
       console.log("📦 Uploaded Data Before API Call:", uploadedData);
      setShowLoader(true);
      const res = await createManyBills(
        activeBranchId,
        JSON.stringify({ bulkData: uploadedData }),
      );
      if (res?.statusCode === 200) {
        getData();
        setShowMessage({
          message: res.message || 'Bulk bill upload successful',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Bulk bill upload failed',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Bulk bill upload failed',
        messageType: 'error',
      });
    } finally {
      setShowLoader(false);
      setIsBulkUploadModalOpen(false);
    }
  };

  // const downloadExcelTemplate = () => {
  //   const templateFileName = Book1Billing;
  //   const a = document.createElement('a');
  //   a.style.display = 'none';
  //   a.href = templateFileName;
  //   a.download = 'billing_template.xlsx';
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // };
//  const downloadExcelTemplate = () => {
//   // Define your template headers here
//   const headers = [
//     'billType', 'clientName', 'clientNumber', 'gender',
//     'dateOfBilling', 'timeOfBilling',
//     'services[0].serviceName', 'services[0].serviceProvider', 'services[0].price',
//     'services[0].discount', 'services[0].discountType', 'services[0].amount', 'services[0].quantity',
//     'amountPaid[0].amount', 'amountPaid[0].paymentType',
//     'subTotal', 'totalAmount', 'amountPayable', 'paidDues'
//   ];

//   // Optional: one sample row so the user sees the expected format
//   const sampleRow = {
//     billType: 'Bill',
//     clientName: 'John Doe',
//     clientNumber: '9876543210',
//     gender: 'Male',
//     dateOfBilling: '2025-01-01',
//     timeOfBilling: '10:30:00',
//     'services[0].serviceName': 'Haircut',
//     'services[0].serviceProvider': 'Staff Name',
//     'services[0].price': 500,
//     'services[0].discount': 0,
//     'services[0].discountType': '%',
//     'services[0].amount': 500,
//     'services[0].quantity': 1,
//     'amountPaid[0].amount': 500,
//     'amountPaid[0].paymentType': 'Cash',
//     subTotal: 500,
//     totalAmount: 500,
//     amountPayable: 500,
//     paidDues: 0
//   };

//   const ws = XLSX.utils.json_to_sheet([sampleRow], { header: headers });
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Template');
//   XLSX.writeFile(wb, 'billing_template.xlsx');
// };

  const openBulkUploadModal = () => {
    setIsBulkUploadModalOpen(true);
  };

  const closeBulkUploadModal = () => {
    setIsBulkUploadModalOpen(false);
  };

  // Rest of your existing functions...
  const getPaymentMethods = () => {
    if (billType === 'Wallet') {
      return filterPaymentMethods.filter(method => method.value !== 'Wallet');
    }
    return filterPaymentMethods;
  };

  const filterOptions = [
    {
      title: 'Gender',
      items: filterGenderWise,
    },
    {
      title: 'Ratings',
      items: filterRatings,
    },
    {
      title: 'Payment Method',
      items: getPaymentMethods(),
    },
    {
      title: 'Services',
      items: services.map((service) => ({
        value: service._id,
        label: service.serviceName,
        gender: service.gender,
      })),
    },
    {
      title: 'Products',
      items: products.map((product) => ({
        value: product._id,
        label: product.productName,
        gender: product.gender,
      })),
    },
    {
      title: 'Service Providers',
      items: serviceProviders.map((provider) => ({
        value: provider._id,
        label: provider.name,
        gender: provider.gender,
      })),
    },
    // {
    //   title: 'Dues',
    //   items: [
    //     { value: 'hasDues', label: 'Show only bills with dues' }
    //   ]
    // }
  ];

  // const handleFilterChange = (selectedValues) => {
  //   const serviceIds = selectedValues.filter(val =>
  //     services.some(service => service._id === val)
  //   );
  //   const productIds = selectedValues.filter(val =>
  //     products.some(product => product._id === val)
  //   );
  //   const providerIds = selectedValues.filter(val =>
  //     serviceProviders.some(provider => provider._id === val)
  //   );
  //   const genderFilters = selectedValues.filter(val =>
  //     filterGenderWise.some(opt => opt.value === val)
  //   );
  //   const ratingFilters = selectedValues.filter(val =>
  //     filterRatings.some(opt => opt.value === val)
  //   );
  //   const paymentFilters = selectedValues.filter(val =>
  //     getPaymentMethods().some(opt => opt.value === val)
  //   );

  //   const dues = selectedValues.includes('hasDues');

  //   dispatch(setBillingFilter({
  //     selectedGenderBy: genderFilters,
  //     selectedRatingBy: ratingFilters,
  //     selectedPaymentMethods: paymentFilters,
  //     selectedServices: serviceIds,
  //     selectedServiceProviders: providerIds,
  //     selectedProducts: productIds,
  //     page: 1
  //   }));
  // };
  // ✅ Modified filter change handler
  const handleFilterChange = (selectedValues) => {
    const serviceIds = selectedValues.filter(val =>
      services.some(service => service._id === val)
    );
    const productIds = selectedValues.filter(val =>
      products.some(product => product._id === val)
    );
    const providerIds = selectedValues.filter(val =>
      serviceProviders.some(provider => provider._id === val)
    );
    const genderFilters = selectedValues.filter(val =>
      filterGenderWise.some(opt => opt.value === val)
    );
    const ratingFilters = selectedValues.filter(val =>
      filterRatings.some(opt => opt.value === val)
    );
    const paymentFilters = selectedValues.filter(val =>
      getPaymentMethods().some(opt => opt.value === val)
    );

    const dues = selectedValues.includes('hasDues');
    const availability = selectedValues.includes('showDeleted'); // Add this line

    dispatch(setBillingFilter({
      selectedGenderBy: genderFilters,
      selectedRatingBy: ratingFilters,
      selectedPaymentMethods: paymentFilters,
      selectedServices: serviceIds,
      selectedServiceProviders: providerIds,
      selectedProducts: productIds,
      dues,
      availability,
      page: 1
    }));

    // ✅ Auto-reset when filters change
    resetCheckedStates();
  };

  const hasActiveFilters = () => {
    return (
      search ||
      startDate ||
      endDate ||
      selectedSortBy.length > 0 ||
      selectedGenderBy.length > 0 ||
      selectedRatingBy.length > 0 ||
      selectedPaymentMethods.length > 0 ||
      selectedServices.length > 0 ||
      selectedServiceProviders.length > 0 ||
      selectedProducts.length > 0 ||
      dues ||
      availability
    );
  };

  const getData = async (isFiltered = false) => {

    // Always use the current page value from Redux state, not a hardcoded value
    const queryParams = {
      limit: isFiltered ? 10000 : limit,
      page: isFiltered ? 1 : page, // Use current page from state
      billType,
      sortValue,
      ...(search && { searchValue: search.trim() }),
      ...(startDate && { startDate: startDate.trim() }),
      ...(endDate && { endDate: endDate.trim() }),
      ...(selectedSortBy.length > 0 && { sortBy: selectedSortBy.join(',') }),
      ...(selectedGenderBy.length > 0 && { gender: selectedGenderBy.join(',') }),
      ...(selectedRatingBy.length > 0 && { ratings: selectedRatingBy.join(',') }),
      ...(selectedPaymentMethods.length > 0 && { paymentMethod: selectedPaymentMethods.join(',') }),
      ...(selectedServices.length > 0 && { services: selectedServices.join(',') }),
      ...(selectedServiceProviders.length > 0 && { staff: selectedServiceProviders.join(',') }),
      ...(selectedProducts.length > 0 && { products: selectedProducts.join(',') }),
      ...(dues && { dues: true }),
      ...(availability && { availability: false }),
    };

    const queryString = Object.entries(queryParams)
      .filter(([_, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    try {
      setShowLoader(true);
      const res = await fetchAllBillings(activeBranchId, `?${queryString}`);

      if (res.statusCode === 200) {
        if (isFiltered) {
          setFullFilteredData(res.data || []);
          setTotalFilteredCount(res.data?.length || 0);
          const startIndex = (page - 1) * limit;
          const endIndex = startIndex + limit;
          setFilteredData(res.data.slice(startIndex, endIndex) || []);
          setAllFilteredDataForSelection(res.data || []);
        } else {
          setData(res.data || []);
          setAllFilteredDataForSelection(res.data || []);
          setFilteredData(res.data || []);
          setTotalFilteredCount(res.totalCount || 0);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    const filtersActive = hasActiveFilters();
    getData(filtersActive);

    if (!filtersActive) {
      setIsModalOpen(false);
    }
  }, [
    activeBranchId,
    billType,
    limit,
    page, // This dependency will trigger getData when page changes
    debouncedSearch,
    startDate,
    endDate,
    selectedSortBy,
    sortValue,
    selectedGenderBy,
    selectedRatingBy,
    selectedPaymentMethods,
    selectedServices,
    selectedServiceProviders,
    selectedProducts,
    dues,
    availability,
    clear
  ]);

  // useEffect(() => {
  //   if (startDate && endDate && fullFilteredData.length > 0) {
  //     const startIndex = (page - 1) * limit;
  //     const endIndex = startIndex + limit;
  //     setFilteredData(fullFilteredData.slice(startIndex, endIndex));
  //     setTotalFilteredCount(fullFilteredData.length);
  //   }
  // }, [page, limit, startDate, endDate, fullFilteredData]);

  useEffect(() => {
    const totals = calculatePageTotals(filteredData);
    setPageTotals(totals);
  }, [filteredData]);

  const calculatePageTotals = (currentPageData) => {
    const totalAmount = currentPageData.reduce((acc, item) => acc + (item.amountPayable || 0), 0);
    const amountPaid = currentPageData.reduce((acc, item) => {
      if (Array.isArray(item.amountPaid)) {
        const totalPaid = item.amountPaid.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
        return acc + totalPaid;
      }
      return acc;
    }, 0);
    const paidDues = currentPageData.reduce((acc, item) => acc + (item.paidDues || 0), 0);

    return { totalAmount, amountPaid, paidDues: isNaN(paidDues) ? 0 : paidDues };
  };

  const handleLimitChange = (e) => {
    console.log(e.target.value, 'pagevalue')
    dispatch(setBillingLimit(e.target.value));
  };

  const handleOnExport = () => {
    // const exportData = startDate && endDate ? fullFilteredData : data;
    const exportData = hasActiveFilters() ? fullFilteredData : data;
    if (!Array.isArray(exportData)) {
      console.error('Data is not an array or is undefined');
      return;
    }

    const selectedFields = [
      'clientName', 'clientNumber', 'gender', 'useMembership', 'dateOfBilling', 'timeOfBilling',
      'subTotal', 'totalAmount', 'amountPayable', 'paidDues', 'advancedGiven', 'preAdvanceUsed',
      'ratings',
    ];

    const flattenedData = exportData.map((item) => {
      const flattenedItem = {};
      selectedFields.forEach((field) => {
        if (item.hasOwnProperty(field)) {
          flattenedItem[field] = item[field];
        }
      });
      if (Array.isArray(item.amountPaid)) {
        flattenedItem.amountPaid = item.amountPaid.reduce((total, item) => total + parseFloat(item.amount), 0);
      }
      if (Array.isArray(item.services)) {
        flattenedItem.serviceName = item.services.map(serviceItem => serviceItem.serviceName).join(', ');
        flattenedItem.serviceProviders = item.services.flatMap(serviceItem => serviceItem?.serviceProviderDetails?.map(pName=>pName?.name) || '').join(', ');
      }
      if (Array.isArray(item.products)) {
        flattenedItem.productName = item.products.map(productItem => productItem.productName).join(', ');
        flattenedItem.productProvider = item.products.flatMap(productItem => productItem?.productProviderDetails?.map(pName=>pName?.name) || '').join(', ');
      }
      return flattenedItem;
    });

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(flattenedData);
    XLSX.utils.book_append_sheet(wb, ws, 'Bills');
    XLSX.writeFile(wb, 'Bills.xlsx');
  };

  const closeModal = () => setIsModalOpen(false);

  const handleDateRangeSelected = (startDate, endDate) => {
    dispatch(setBillingFilter({ startDate, endDate, page: 1 }));
    setClear(true);
    setIsModalOpen(false);
  };

  // ✅ RESET FUNCTION - Called when dialogs close or filters change
  const resetCheckedStates = useCallback(() => {
    setCheckedClients([]);
    setIsAllChecked(false);
    setSelectedTemplate(null);
    setTemplateVariables({});
    setSendError(null);
    setValidationError('');
  }, []);

  const handleManualReset = () => {
    resetCheckedStates();
  };

  // ✅ MODIFY search handler ko preserve selection
 const handleSearchChange = (e) => {
    // Remove only leading spaces while typing (so spaces between words still work)
    dispatch(setBillingFilter({ search: e.target.value.trimStart(), page: 1 }));
    // Selection preserve rahega, automatic reset nahi hoga
  };

// Runs when the user pastes into the search box
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();

    // If it looks like a phone number, clean it (remove spaces, dashes, brackets, +91)
    const isPhoneLike = /^[+\d\s\-()]+$/.test(pasted);
    const cleaned = isPhoneLike
      ? pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '')
      : pasted;

    dispatch(setBillingFilter({ search: cleaned, page: 1 }));
  };

  // ✅ Reset when WhatsApp dialog closes
  useEffect(() => {
    if (!openWhatsAppDialog && !openConfirmationDialog) {
      resetCheckedStates();
    }
  }, [openWhatsAppDialog, openConfirmationDialog, resetCheckedStates]);

  // ✅ Reset when filters change
  // useEffect(() => {
  //   resetCheckedStates();
  // }, [
  //   search, startDate, endDate, selectedSortBy, selectedGenderBy,
  //   selectedRatingBy, selectedPaymentMethods, selectedServices,
  //   selectedServiceProviders, selectedProducts, dues,
  //   resetCheckedStates
  // ]);

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  // Validate phone numbers
  const validatePhoneNumbers = (clients) => {
    const invalidNumbers = clients.filter(client => {
      const number = client.clientNumber.toString().replace(/\D/g, '');
      return number.length < 10 || number.length > 15;
    });

    if (invalidNumbers.length > 0) {
      return `Invalid phone numbers found: ${invalidNumbers.map(c => c.clientNumber).join(', ')}`;
    }
    return null;
  };

  // Prepare WhatsApp payload with proper variable segregation
  const prepareWhatsAppPayload = (template, clients) => {
    if (!template || !clients || clients.length === 0) {
      throw new Error('Template or clients data is missing');
    }

    const numbers = clients.map((client) => {
      const number = client.clientNumber.toString().replace(/\D/g, '');
      return number.startsWith('91') ? number : `${number}`;
    });

    const payload = {
      numbers: numbers,
      template_name: template.name,
    };

    // Separate body and button variables (skip header variables)
    const bodyVariables = {};
    const buttonVariables = {};

    template.variables.forEach((variable, index) => {
      // Skip header variables — they are handled via file upload
      const varType = template.variableTypes?.[variable];
      if (varType && varType.type !== 'text') return;

      const varKey = `var_${index + 1}`;
      const value = template.variableValues?.[varKey] || '';

      if (variable.toLowerCase().includes('button')) {
        const buttonIndex = variable.split('_')[1] || (index + 1);
        buttonVariables[`button${buttonIndex}`] = value;
      } else {
        const bodyIndex = variable.split('_')[1] || (index + 1);
        bodyVariables[`var${bodyIndex}`] = value;
      }
    });

    // Merge body and button variables into payload
    Object.assign(payload, bodyVariables, buttonVariables);

    // Include headerFile if present
    if (template.headerFile) {
      payload.headerFile = template.headerFile;
    }

    return payload;
  };

  // Updated WhatsApp sending function with validation
  const handleSendBulkWhatsApp = async () => {
    try {
      // Validation checks
      if (!selectedTemplate) {
        throw new Error('Please select a WhatsApp template');
      }

      if (!checkedClients || checkedClients.length === 0) {
        throw new Error('No clients selected for WhatsApp messaging');
      }

      const phoneValidationError = validatePhoneNumbers(checkedClients);
      if (phoneValidationError) {
        throw new Error(phoneValidationError);
      }

      // Validate template variables (skip header variables)
      const missingVariables = selectedTemplate.variables.filter((variable, index) => {
        const varType = selectedTemplate.variableTypes?.[variable];
        if (varType && varType.type !== 'text') return false; // skip header vars
        const varKey = `var_${index + 1}`;
        return !selectedTemplate.variableValues?.[varKey]?.trim();
      });

      if (missingVariables.length > 0) {
        throw new Error(`Please fill all template variables: ${missingVariables.join(', ')}`);
      }

      // Prepare payload
      const payload = prepareWhatsAppPayload(selectedTemplate, checkedClients);

      console.log('Final Payload:', payload);

      // Start sending process
      setIsSending(true);
      setSendProgress(0);
      setSendError(null);

      // Simulate progress updates
      const progressInterval = setInterval(() => {
        setSendProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return prev;
          }
          return prev + 10;
        });
      }, 300);

      // API call
      const res = await sendBulkWhatsApp(payload, activeBranchId);

      clearInterval(progressInterval);
      setSendProgress(100);

      if (res.statusCode === 200) {
        showSnackbar(`WhatsApp messages sent successfully to ${checkedClients.length} clients`, 'success');

        // ✅ Reset everything after success
        setTimeout(() => {
          resetCheckedStates();
          setOpenConfirmationDialog(false);
          setOpenWhatsAppDialog(false);
          setIsSending(false);
          setSendProgress(0);
        }, 2000);

      } else {
        throw new Error(res.message || 'Failed to send WhatsApp messages');
      }
    } catch (error) {
      console.error('WhatsApp sending error:', error);
      setSendError(error.message);
      showSnackbar(error.message, 'error');
      setIsSending(false);
      setSendProgress(0);
    }
  };

  // ✅ Modified Template Selection Dialog onClose
  const handleTemplateDialogClose = () => {
    if (!isSending) {
      setOpenWhatsAppDialog(false);
      resetCheckedStates();
    }
  };

  // ✅ Modified Confirmation Dialog onClose
  const handleConfirmationDialogClose = () => {
    if (!isSending) {
      setOpenConfirmationDialog(false);
      // Don't reset checked clients here if user just cancels confirmation
      // but keep template selection for next time
    }
  };

  // Template confirmation handler
  const handleTemplateConfirm = (templateWithVariables) => {
    console.log('Template confirmed:', templateWithVariables);

    // Validate template variables before confirmation (skip header variables)
    const missingVariables = templateWithVariables.variables.filter((variable, index) => {
      const varType = templateWithVariables.variableTypes?.[variable];
      if (varType && varType.type !== 'text') return false; // skip header vars
      const varKey = `var_${index + 1}`;
      return !templateWithVariables.variableValues?.[varKey]?.trim();
    });

    if (missingVariables.length > 0) {
      setValidationError(`Please fill all required variables: ${missingVariables.join(', ')}`);
      return;
    }

    setSelectedTemplate(templateWithVariables);
    setValidationError('');
    setOpenConfirmationDialog(true);
  };

  const fetchWhatsAppTemplates = async () => {
    try {
      setShowLoader(true);
      const res = await getWhatsAppTemplates();
      console.log(res, 'resssssssss');
      // if (res.status === "success" && res.data) {

      const templatesData = res?.templates?.data || res?.data;

      if (templatesData && Array.isArray(templatesData)) {
        // Filter only approved templates - nested structure ke according
                // const approvedTemplates = res.data.filter(template => {

        const approvedTemplates = templatesData.filter(template => {
          // Check if template has languages array and first language has APPROVED status
          return template.languages &&
            template.languages.length > 0 &&
            // template.languages[0].status === "APPROVED";
                        template.languages[0].status?.toUpperCase() === "APPROVED";
        });

        console.log('Approved Templates:', approvedTemplates);
        setTemplates(approvedTemplates);
        setOpenWhatsAppDialog(true);
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch templates',
          messageType: 'error'
        });
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
      setShowMessage({
        message: 'Failed to fetch templates',
        messageType: 'error'
      });
    } finally {
      setShowLoader(false);
    }
  };
// useImperativeHandle(ref, () => ({
//   getExportData: () => (startDate && endDate ? fullFilteredData : data),
// }));
useImperativeHandle(ref, () => ({
  getExportData: () => (hasActiveFilters() ? fullFilteredData : data),
}));

  console.log(templates, 'templates')
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0px 1.5rem 30px' }}>
        {/* Show per page - Left side */}
        <div style={{ width: '100px', marginBottom: '20px' }}>
          <InputLabel>Show per page</InputLabel>
          <Select
            style={{
              borderRadius: '7px',
              border: '0.5px solid #6174DD',
              padding: '4px 12px',
              background: '#FFF',
              height: '40px',
              width: '100%',
            }}
            value={limit}
            onChange={handleLimitChange}
          >
            {[10, 50, 100, 200].map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>              
            ))}
             <MenuItem value={1000000}>All</MenuItem>
          </Select>
        </div>

        {/* Right side buttons: Search, Filter, Download */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', flexWrap: 'wrap' }}>
          {/* Search */}
          <div style={{ width: '170px', marginBottom: '25px' }} onClick={() => document.getElementById('search-input').focus()}>
            <InputLabel>Search</InputLabel>
          <div className="search-input" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: '100%', boxSizing: 'border-box' }}>              <img src={SearchImg} alt="" style={{ verticalAlign: 'middle' }} />
              {/* <input
                id="search-input"
                style={{ flex: 1, padding: '4px 2px', borderRadius: '7px', width: '100%' }}
                type="text"
                placeholder=""
                value={search}
                onChange={(e) => dispatch(setBillingFilter({ search: e.target.value }))}
              /> */}
              <input
                id="search-input"
                style={{ flex: 1, padding: '4px 2px', borderRadius: '7px', width: '100%' }}
                type="text"
                placeholder="Search Clients..."
                value={search}
                onChange={handleSearchChange}
                onPaste={handleSearchPaste}
              />
              {search && (
                <IconButton
                  onClick={() => {
                    dispatch(setBillingFilter({ search: '' }));
                    setClear(false);
                  }}
                  style={{ padding: 1 }}
                >
                  <MdClear style={{ color: '#000', marginRight: '-0.1rem', marginTop: '0.1rem', fontSize: '1.1rem' }} />
                </IconButton>
              )}
            </div>
          </div>

          {/* Filter */}
          <div style={{ width: '150px',marginTop:'2px' }}>
            <FilterBillPage
              options={filterOptions}
              value={[
                ...selectedGenderBy,
                ...selectedRatingBy,
                ...selectedPaymentMethods,
                ...selectedServices,
                ...selectedServiceProviders,
                ...selectedProducts,
              ]}
              onChange={handleFilterChange}
              placeholder="Filters"
              selectedStartDate={startDate}
              selectedEndDate={endDate}
              onDateRangeSelected={(start, end) => {
                dispatch(setBillingFilter({ startDate: start, endDate: end }));
              }}
              onClearDate={() => {
                dispatch(setBillingFilter({ startDate: '', endDate: '' }));
              }}
              loadingServices={loadingServices}
              loadingProviders={loadingProviders}
              hasDues={dues}
              onToggleDues={(newDuesValue) => {
                dispatch(setBillingFilter({ dues: newDuesValue, page: 1 }));
              }}
              hasAvailability={availability} // Add this prop
              onToggleAvailability={(newAvailabilityValue) => { // Add this prop
                dispatch(setBillingFilter({ availability: newAvailabilityValue, page: 1 }));
              }}
              products={products} // Add this line to pass products
              onProductSelectionChange={(selectedProductIds) => {
                dispatch(setBillingFilter({ selectedProducts: selectedProductIds, page: 1 }));
              }}
            />
          </div>

          {/* Bulk Upload Button */}
          {/* <div style={{ width: '150px' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={openBulkUploadModal}
              sx={{
                height: '40px',
                width: '100%',
                padding: '0.3rem',
                '&:hover': { background: '#6174DD' },
              }}
            >
              Bulk Upload
            </Button>
          </div> */}

          {/* Bulk PDF Download Button */}
          {
            !hideDownloadButton && (
              <div style={{ width: 'auto' }}>
                <Button
                  variant="contained"
                  color="primary"
                  title="Bulk Download Bill PDF"
                  sx={{
                    height: '40px',
                    padding: '0.3rem 1rem',
                    '&:hover': { background: '#6174DD' },
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                  onClick={handleDownloadBulkPdf}
                >
                        <FaDownload style={{ fontSize: '1.2rem' }} />
                  {/* <FaFilePdf style={{ fontSize: '1.2rem' }} /> */}
                  PDF
                </Button>
              </div>
            )
          }
          {/* Download Button */}
          {
            !hideDownloadButton && (
              <div style={{ width: 'auto' }}>
                <Button
                  variant="contained"
                  color="primary"
                  title="Download Bills"
                  sx={{
                    height: '40px',
                    padding: '0.3rem 1rem',
                    '&:hover': { background: '#6174DD' },
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                  onClick={handleOnExport}
                >
                        <FaDownload style={{ fontSize: '1.2rem' }} />
                  {/* <FaFileExcel style={{ fontSize: '1.2rem' }} /> */}
                  Excel
                </Button>
              </div>
            )
          }
        </div>
      </div>

      {showLoader ? (
        <ShowLoader />
      ) : (
        <Box>
          {filteredData && filteredData.length > 0 ? (
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                {/* <FieldData
                  data={filteredData}
                  setData={setData}
                  getData={getData}
                  billType={billType}
                  ownerId={ownerId}
                  allClient={allClient}
                  checkedClients={checkedClients}
                  setCheckedClients={setCheckedClients}
                /> */}
                <FieldData
                  data={filteredData} // Current page data for display
                  allData={hasActiveFilters() ? fullFilteredData : data} // All data for selection
                  setData={setData}
                  getData={getData}
                  billType={billType}
                  ownerId={ownerId}
                  allClient={allClient}
                  checkedClients={checkedClients}
                  setCheckedClients={setCheckedClients}
                  hasActiveFilters={hasActiveFilters()}
                  isAllChecked={isAllChecked}
                  setIsAllChecked={setIsAllChecked}

                />

              </Grid>
            </Grid>
          ) : (
            <div style={{ marginTop: '2rem' }} variant="h6" align="center">
              No data found
            </div>
          )}
        </Box>
      )}

      <Box display={'flex'} justifyContent={'flex-end'}>
        <Pagination
          count={hasActiveFilters() ? Math.ceil(totalFilteredCount / limit) : page + 1}
          page={page}
          color="primary"
          onChange={(e, newPage) => {
            dispatch(setBillingPage(newPage));
            // getData(hasActiveFilters());
          }}
        />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        style={{
          width: '100%',
          marginLeft: '0.5rem',
          marginTop: '1rem',
          padding: '1rem',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
        }}
      >
        <Typography variant="h6" fontWeight="600" gutterBottom>
          Amount as per Page
        </Typography>

        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Amount:</strong> ₹ {pageTotals.totalAmount}
          </Typography>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Paid:</strong> ₹ {pageTotals.amountPaid}
          </Typography>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Pending:</strong> ₹ {pageTotals.paidDues}
          </Typography>
        </Box>
      </Box>

      {/* Bulk Upload Modal */}
      <Dialog open={isBulkUploadModalOpen} onClose={closeBulkUploadModal}>
        <DialogTitle>Bulk Upload Bills</DialogTitle>
        <form onSubmit={handleBulkUploadSubmit}>
          <DialogContent>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
            />
            {showLoader && <ShowLoader />}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeBulkUploadModal}>Cancel</Button>
            {/* <Button 
              variant="outlined"
              color="primary"
              onClick={downloadExcelTemplate}
              startIcon={<ArrowCircleDownIcon />}
            >
              Sample Download
            </Button> */}
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <DateRangeInputs
        isOpen={isModalOpen}
        onClose={closeModal}
        onDateRangeSelected={handleDateRangeSelected}
        selectedEndDate={endDate}
        selectedStartDate={startDate}
      />
      {/* Selected Clients Card */}
      {/* {checkedClients.length > 0 && (
        <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }} style={{ marginTop: '30px', width: '100%', height: '95px' }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" padding={'5px'}>
              <Box style={{ padding: '5px' }}>
                <Typography variant="h6" gutterBottom>
                  📱 Ready to Send WhatsApp
                </Typography>
                <Box display="flex" gap={2} alignItems="center" marginTop={'10px'}>
                  <Chip
                    label={`${checkedClients.length} clients selected`}
                    color="primary"
                    variant="outlined"
                  />
                  <Typography variant="body2" color="text.secondary">
                    {checkedClients.length} clients will receive WhatsApp messages
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="contained"
                startIcon={<WhatsAppIcon />}
                onClick={fetchWhatsAppTemplates}
                sx={{
                  background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
                  borderRadius: '8px',
                  px: 3,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
                  }
                }}
              >
                Send Bulk WhatsApp
              </Button>
            </Box>
          </CardContent>
        </Card>
      )} */}
      {checkedClients.length > 0 && (
        <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }} style={{ marginTop: '30px', width: '100%', height: '95px' }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" padding={'5px'}>
              <Box style={{ padding: '5px' }}>
                <Typography variant="h6" gutterBottom>
                  📱 Ready to Send WhatsApp
                </Typography>
                <Box display="flex" gap={2} alignItems="center" marginTop={'10px'}>
                  <Chip
                    label={`${checkedClients.length} clients selected`}
                    color="primary"
                    variant="outlined"
                  />
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleManualReset}
                    size="small"
                  >
                    Clear Selection
                  </Button>
                </Box>
              </Box>
              <Button
                variant="contained"
                startIcon={<WhatsAppIcon />}
                onClick={fetchWhatsAppTemplates}
                sx={{
                  background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
                  borderRadius: '8px',
                  px: 3,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
                  }
                }}
              >
                Send Bulk WhatsApp
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Template Selection Dialog */}
      {/* <TemplateSelectionDialog
        open={openWhatsAppDialog}
        templates={templates}
        onClose={() => {
          if (!isSending) {
            setOpenWhatsAppDialog(false);
            setSelectedTemplate(null);
            setSendError(null);
            setValidationError('');
          }
        }}
        onConfirm={handleTemplateConfirm}
        isSending={isSending}
        sendProgress={sendProgress}
        sendError={sendError}
        validationError={validationError}
      /> */}
      <TemplateSelectionDialog
        open={openWhatsAppDialog}
        templates={templates}
        onClose={handleTemplateDialogClose} // Use modified handler
        onConfirm={handleTemplateConfirm}
        isSending={isSending}
        sendProgress={sendProgress}
        sendError={sendError}
        validationError={validationError}
        setSendError={setSendError}
      />

      {/* Confirmation Dialog */}
      <Dialog
        open={openConfirmationDialog}
        onClose={handleConfirmationDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
          <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
            <WhatsAppIcon color="success" />
            <Typography variant="h6">
              {isSending ? `Sending... ${sendProgress}%` : 'Confirm WhatsApp Send'}
            </Typography>
          </Box>
          {isSending && (
            <LinearProgress
              variant="determinate"
              value={sendProgress}
              sx={{ mt: 1 }}
            />
          )}
        </DialogTitle>

        <DialogContent>
          {sendError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {sendError}
            </Alert>
          )}

          <Alert severity="info" sx={{ mb: 2 }}>
            You're about to send WhatsApp messages to {checkedClients.length} clients
          </Alert>

          {selectedTemplate && (
            <Box>
              <Typography variant="subtitle2" gutterBottom>
                Template: <strong>{selectedTemplate.name}</strong>
              </Typography>

              <Box mt={2}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Message Preview:
                </Typography>
                <Card variant="outlined" sx={{ p: 2, bgcolor: '#fafafa' }}>
                  <Typography variant="body2" whiteSpace="pre-wrap">
                    {selectedTemplate.bodyText || 'No message content'}
                  </Typography>
                </Card>
              </Box>

              {selectedTemplate.variables.length > 0 && (
                <Box mt={2}>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    Variables to be sent:
                  </Typography>
                  {selectedTemplate.variables.map((variable, index) => (
                    <Chip
                      key={variable}
                      label={`${variable}: ${selectedTemplate.variableValues?.[`var_${index + 1}`] || 'Not set'}`}
                      size="small"
                      sx={{ mr: 1, mb: 1 }}
                      variant="outlined"
                      color={selectedTemplate.variableValues?.[`var_${index + 1}`] ? "success" : "default"}
                    />
                  ))}
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button
            onClick={handleConfirmationDialogClose}
            variant="outlined"
            sx={{ borderRadius: '6px' }}
            disabled={isSending}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendBulkWhatsApp}
            variant="contained"
            startIcon={<WhatsAppIcon />}
            disabled={isSending}
            sx={{
              background: isSending
                ? '#ccc'
                : 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
              borderRadius: '6px',
              px: 3,
              '&:hover': isSending ? {} : {
                background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
              },
              '&:disabled': {
                background: '#ccc'
              }
            }}
          >
            {isSending ? `Sending... ${sendProgress}%` : `Send to ${checkedClients.length} Clients`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </>
  );
});

export default AllBillings;